import { Variant } from "@interfaces/Variant"
import { getListingTypeTheme } from "@utils/ListingUtils"
import { CloudStoreAttributeEnum } from "cs.node.utils/BindingUtils"
import { ChildListingStatusEnum, ChildListingTypeEnum } from "cs.node.utils/csapi/provisioning"
import { PropertyAnalysis } from "cs.node.utils/ItemUtils"
import { Badge } from "react-bootstrap"

const en = {
    __LANGUAGE: "en",
    ACCEDI: "Sign in",
    ACCESSO_IN_CORSO: "Logging in...",
    LOGIN: "Login",
    RICORDAMI: "Remember me",
    CREDENZIALI_NON_RICONOSCIUTE: "Unrecognized credentials",
    CERCA: "Search",
    CHANGE_PASSWORD: {
        PASSWORD_DIMENTICATA: "Forgot password?",
        RECUPERA_PASSWORD: "Recover password",
        RECUPERA_PASSWORD_DESC: "Enter your email to receive instructions for resetting your password.",
        EMAIL: "Email",
        INVIA: "Send",
        RICHIESTA_INVIATA_CON_SUCCESSO: "Request sent successfully. Check your email inbox.",
        TORNA_ALLA_LOGIN: "Back to login",
        CONFERMA_INVIO_EMAIL_RESET_PASSWORD: (email: string) => `Do you confirm the sending of the password reset email to ${email}?`,
        CIAO: (username: string) => <>Hello, <strong>{username}</strong>!</>,
        DESC: "Choose a new password for your account.",
        CAMBIA_PASSWORD: "Change password",
        CONFERMA_CAMBIO_PASSWORD: "Do you confirm the password change?",
        PASSWORD_REGEX: "Password must be long between 8 and 64 characters, must contain at least one lower case letter and one upper case letter, must contain at least a digit and at least one of the following special characters: @ # $ % ^ & + = !",
        NUOVA_PASSWORD: "New password",
        CONFERMA_NUOVA_PASSWORD: "Confirm new password",
        ERR_PASSWORD_DIFFERENTI: "New password and confirm new password must match",
        ERR_FORMATO_PASSWORD_LOWER_CASE: "Password must contain at least one lower case letter",
        ERR_FORMATO_PASSWORD_UPPER_CASE: "Password must contain at least one upper case letter",
        ERR_FORMATO_PASSWORD_DIGIT: "Password must contain at least one digit",
        ERR_FORMATO_PASSWORD_SPECIAL: "Password must contain at least one special character: @ # $ % ^ & + = !",
        PASSWORD_CAMBIATA_CON_SUCCESSO: "Your password has been changed successfully.",
        VAI_ALLA_LOGIN: "Go to login"
    },
    SOTTOUTENTI: "Subusers",
    BILLING: "Billing",
    MODULI: "Forms",
    LOGOUT: "Logout",
    CONFERMA_LOGOUT: "Are you sure you want to logout?",
    COPIA: "Copy",
    COPIATO: "Copied!",
    OK: "Ok",
    MODIFICA: "Edit",
    ELIMINA: "Delete",
    VISUALIZZA: "View",
    ORDINA: "Order",
    AGGIUNGI: "Add",
    AGGIORNA: "Refresh",
    CARICA: "Upload",
    ANNULLA: "Cancel",
    INDIETRO: "Back",
    CHIUDI: "Close",
    RIFIUTA: "Reject",
    RIPRISTINA: "Restore",
    RIGENERA: "Regenerate",
    NESSUNO: "No one",
    NESSUN_ELEMENTO_PRESENTE: "No entries found",
    NESSUN_RISULTATO_TROVATO: "No results found",
    SELEZIONA: "Select",
    SELEZIONA_TUTTI: "Select all",
    DESELEZIONA_TUTTI: "Deselect all",
    ABILITATO: "Enabled",
    DISABILITATO: "Disabled",
    RIUSCITO: "Successful",
    FALLITO: "Failed",
    CONFERMA: "Confirm",
    ATTENDERE: "Please wait",
    ATTENZIONE: "Warning",
    ERRORE_GENERICO: "An error occurred, please try again.",
    RIPROVA: "Retry",
    DETTAGLI_ERRORE: "Error details",
    SELEZIONA_UN_VALORE: "Select a value",
    SELEZIONA_MODALITA_CARICAMENTO: "Select the upload mode:",
    VIA_FILE: "Via file",
    VIA_URL: "Via URL",
    VIA_TESTO: "Via text",
    SELEZIONA_FILE_DA_CARICARE: "Select the file to upload",
    URL_DA_CARICARE: "URL to upload",
    SELEZIONA_UN_FILE: "Select a file",
    SI: "Yes",
    NO: "No",
    TUTTI: "All",
    SALES_ORDER: "Sales order",
    TRANSFER_ORDER: "Transfer order",
    SALVA: "Save",
    APPLICA: "Apply",
    SCARICA: "Download",
    E_MAIL: "Email",
    ELIMINAZIONE_IN_CORSO: "Deletion in progress...",
    SALVATAGGIO_IN_CORSO: "Saving in progress...",
    OPERAZIONE_AVVENUTA_CON_SUCCESSO: "Operation completed successfully",
    COPIA_VALORE: "Copy value",
    COPIA_ID: "Copy ID",
    PROCEDI: "Proceed",
    PROSEGUI: "Continue",
    CAMBIA: "Change",
    CREA: "Create",
    ISTRUZIONI: "Instructions",
    DETTAGLI: "Details",
    MOSTRA: "Show",
    RICERCA_IN_CORSO: "Searching...",
    RISULTATI: (count:number)=>count===1?`1 result`:`${count} results`,
    SELEZIONATI: (count:number)=>`${count} selected`,
    HOME: "Home",
    INIZIA: "Start",
    VERIFICA: "Verify",
    SELEZIONA_FILE: "Select file",
    CLICCA_PER_COPIARE: "Click to copy",
    SALE_CHANNEL: "Sales Channel",
    SALES_CHANNEL: "Sales Channels",
    BADGE_SHOP_PRIMARY: "Primary Shop",
    MARKUP: "Markup",
    DISCOUNT: "Discount",
    TAX_RATE: "Tax Rate",
    COUNTRY: "Country",
    MINIMO: "Min",
    MASSIMO: "Max",
    ZERO_NON_AMMESSO: "Non-zero value",
    ATTIVA: "Enable",
    DISATTIVA: "Disable",
    CONTACTS: {
        EMAIL: "Email",
        PHONE: "Phone",
        MOBILE: "Mobile"
    },
    DATE_UTILS: {
        GIORNI: (days: number)=>days===1?"day":"days",
        ORE: (hours: number)=>hours===1?"hour":"hours",
        MINUTI: (minutes: number)=>minutes===1?"minute":"minutes",
        SECONDI: (seconds: number)=>seconds===1?"second":"seconds",
        MILLISECONDI: (seconds: number)=>seconds===1?"ms":"ms",
    },
    SEARCH_BAR: {
        ARTICOLI: (count: number)=>count===1?`${count} Item`:`${count} Items`,
        ORDINI: (count: number)=>count===1?`${count} Order`:`${count} Orders`,
        SHOP: (count: number)=>count===1?`${count} Shop`:`${count} Shops`,
        CLIENTI: (count: number)=>count===1?`${count} Customer`:`${count} Customers`,
    },
    MENU: {
        IL_TUO_CLOUDSTORE: "Your CloudStore",
        ATTIVITA: "Activity",
        GESTIONE: "Management",
        DASHBOARD: "Dashboard",
        CATALOGO: "Catalog",
        ORDINI: "Orders",
        SPEDIZIONI: "Shipping",
        CLIENTI: "Customers",
        SHOPS: "Shops",
        ASSOCIAZIONE_MAGAZZINI: "Warehouse Bindings",
        MAGAZZINI: "Warehouses",
        LISTA: "List",
        LISTA_ARTICOLI: "Item list",
        SHIPMENTS: "Shipments",
        LISTING: "Listing",
        LISTING_ELENCO: "List",
        LISTINI: "Pricebooks",
        ASSOCIAZIONE_VALORI: "Value binding",
        AGGIORNAMENTO_DISPONIBILITA: "Availability adjustments",
        WHS_MOVEMENTS: "Warehouse movements",
        CATEGORIES: "Categories",
        RETURNS: "Returns",
        GESTIONE_PREZZI: "Price Management",
        CONDIZIONI_COMMERCIALI: "Business Conditions",
        MODIFICA_CONDIZIONE_COMMERCIALE: "Edit business condition",
        LOGS: "Logs",
        PACKAGING: "Packaging",
        STAMPA_ETICHETTE: "Labels printing",
        GROUPAGE: "Groupage",
        LOGS_SETTINGS: "Log settings",
        RISERVE: "Reservations",
        QUEUES: "Queues",
        REGOLE_ESCLUSIONE_LISTING: "Listing Exclusion rules",
        REGOLE_ESCLUSIONE: "Exclusion rules",
        MODIFICA_REGOLA_ESCLUSIONE_LISTING: "Edit listing exclusion rule",
        CUSTOMERS: "Customers",
        MODULI: "Modules",
        REPORT: "Report",
        CONFIGURAZIONE_REPORT: "Report settings",
        AVAILABILITY_BUCKET: "Availability Buckets",
        DAM: "DAM",
        UTENTI: "Users",
        EXPORT: "Export",
        PROFILO: "Profile",
    },
    PAGE_ACCESS_DENIED: {
        TITLE: "Access Denied",
        SUBTITLE: "You cannot access the requested resource.",
        BACK_TO_HOME: "Back to home"
    },
    PAGE_NOT_FOUND: {
        TITLE:"Page not found",
        SUBTITLE:"The requested resource does not exists.",
        BACK_TO_HOME:"Back to home"
    },
    PAGE_ONLY_DESKTOP_OR_TABLET: {
        TITLE:"Page not available on mobile",
        SUBTITLE:"The requested resource is not available on mobile devices.",
        BACK_TO_HOME:"Back to home"
    },
    PAGE_AVAILABILITY_BUCKETS: {
        NUOVO_BUCKET: "Add bucket",
        SHOP_CONTENUTI: "Shops included",
        SHOP_DA_AGGIUNGERE: "Shops to add",
        NOME: "Name"
    },
    PAGE_MAINTENANCE: {
        TITLE: "Maintenance in progress",
        SUBTITLE: "We are performing maintenance operations, but we will be back online soon.",
    },
    PAGE_HOME: {
        BENVENUTO: (name: string)=><>Welcome, {name}</>,
        RIEPILOGO: "This is a summary of your activities.",
    },
    PAGE_BUSINESS_CONDITIONS: {
        NUOVA_CONDIZIONE_COMMERCIALE: "New business condition",
        AVVIA_ELABORAZIONE: "Start processing",
        TEST_CONDIZIONI_COMMERCIALI: "Run a test of business conditions",
        TUTTE_LE_CONDIZIONI_COMMERCIALI_APPLICATE: "All business conditions are applied.",
        DA_ELABORARE: "There are __ELEMENTS__ to process.",
        ASSOCIAZIONI_CON_SHOPS: "Associations with shops",
        ASSOCIAZIONI_CON_CUSTOMER: "Associations with customers",
        RISULTATI_ASSOCIAZIONE: "Association results",
        SHOP_GIA_ASSOCIATO: (navigateFunction: Function)=><>Shop already associated with a business condition. Click <span className="cs-link" onClick={()=>navigateFunction()}>here</span> to edit it.</>,
        SHOP_ASSOCIATO_CORRETTAMENTE: "Shop associated successfully.",
        CONDIZIONI: "Conditions",
        CONDIZIONI_ATTIVE: "Active conditions",
        CONDIZIONI_DA_ELABORARE: "Conditions to process",
        CONDIZIONI_DISABILITATE: "Disabled conditions",
        CONDIZIONI_CANCELLATE: "Canceled conditions",
        CONDIZIONI_IN_ELABORAZIONE: "Conditions in processing",
        TAB_0: "Active / to process / disabled conditions",
        CONFERMA_DISABILITA: "Confirm the deactivation of condition __NAME__?",
        CONFERMA_CANCELLAZIONE: "Confirm the cancellation of condition __NAME__?",
        CONFERMA_ABILITA: "Confirm the enabling of condition __NAME__?",
        CONFERMA_ANNULLAMENTO: "Confirm the cancellation of the ongoing operation for condition __NAME__?",
        CONFERMA_AVVIO_ELABORAZIONE: "Confirm the start of processing business conditions?",
        DATI_GENERALI: "General data",
        NOME: "Name",
        TAX_RATE: "Tax Rate",
        CONDIZIONE_DI_DEFAULT: "Default condition",
        ASSOCIAZIONE_SHOP: "Shop association",
        ASSOCIAZIONE_CUSTOMER: "Customer association",
        ECCEZIONI: "Exceptions",
        ASSOCIAZIONE_SHOP_INFO: "In this section, you can associate this business condition with one or more shops.",
        AGGIUNGI_ASSOCIAZIONE: "Add association",
        NUOVA_ASSOCIAZIONE: "New association",
        CONFERMA_ASSOCIAZIONE_SHOP: "Confirm the association of this business condition with the selected shops?",
        CONFERMA_CANCELLAZIONE_ASSOCIAZIONE_SHOP: "Confirm the cancellation of the selected association?",
        ASSOCIAZIONE_CUSTOMER_INFO: "In this section, you can associate this business condition with one or more customers.",
        CONFERMA_ASSOCIAZIONE_CUSTOMER: "Confirm the association of this business condition with the selected customers?",
        CONFERMA_CANCELLAZIONE_ASSOCIAZIONE_CUSTOMER: "Confirm the cancellation of the selected association?",
        SELEZIONA_UN_CUSTOMER: "Select a customer",
        ECCEZIONI_INFO: "In this section, you can define exceptions to the default condition defined in the header.",
        NUOVA_ECCEZIONE: "New exception",
        MODIFICA_ECCEZIONE: "Edit exception",
        SCARICA_TEMPLATE: "Download empty Excel template",
        SCARICA_ECCEZIONI: "Download Excel of configured exceptions",
        CARICA_ECCEZIONI: "Upload Excel of exceptions for this business condition",
        SELEZIONA_ALMENO_UN_ATTRIBUTO: "Select at least one attribute to apply the condition",
        CONFERMA_SALVATAGGIO_CONDIZIONE: "Confirm the saving of the changes made?",
        LOGS: "Activity Logs",
        TABLE: {
            NOME: "Name",
            VARIAZIONE: "Variation",
            MARKUP: "Markup",
            DISCOUNT: "Discount",
            NUMERO_ECCEZIONI: "No. of Exceptions",
            STATO: "Status",
            VAI_A_DETTAGLIO: "Go to details",
            DISABILITA: "Disable",
            CANCELLA: "Delete",
            RIATTIVA: "Reactivate",
            ANNULLA_OPERAZIONE: "Cancel operation"
        },
        STATUS: {
            LABEL: {
                PENDING: "To be processed",
                PROCESSING: "In processing",
                CONFIRMED: "Confirmed",
                TO_BE_DEPRECATED: "To be deprecated",
                DEPRECATED: "Deprecated",
                TO_BE_DISABLED: "To be disabled",
                DISABLED: "Disabled",
                TO_BE_CANCELED: "To be canceled",
                CANCELED: "Canceled",
                TO_BE_ENABLED: "To be enabled"
            },
            SHORT: {
                PENDING: "This condition is waiting for confirmation and activation.",
                PROCESSING: "This condition is currently being processed.",
                CONFIRMED: "This condition is confirmed and currently active.",
                TO_BE_DEPRECATED: "This condition is scheduled to be deprecated in the next processing.",
                DEPRECATED: "This condition is deprecated and no longer active.",
                TO_BE_DISABLED: "This condition is scheduled to be disabled in the next processing.",
                DISABLED: "This condition is currently disabled and not applied.",
                TO_BE_CANCELED: "This condition is scheduled to be canceled in the next processing.",
                CANCELED: "This condition is canceled.",
                TO_BE_ENABLED: "This condition is scheduled to be enabled in the next processing."
            },
            EXTENDED: {
                PENDING: "This condition is waiting for confirmation and activation.",
                PROCESSING: "This condition is currently being processed.",
                CONFIRMED: "This condition is confirmed and currently active.",
                TO_BE_DEPRECATED: "This condition is scheduled to be deprecated in the next processing.",
                DEPRECATED: "This condition is deprecated and no longer active.",
                TO_BE_DISABLED: "This condition is scheduled to be disabled in the next processing.",
                DISABLED: "This condition is currently disabled and not applied.",
                TO_BE_CANCELED: "This condition is scheduled to be canceled in the next processing.",
                CANCELED: "This condition is canceled.",
                TO_BE_ENABLED: "This condition is scheduled to be enabled in the next processing."
            }
        },
        EXCEPTIONS: {
            SEASON: "Season",
            BRAND: "Brand",
            CATEGORY: "Category",
            SKU_PARENT: "SKU Parent",
            PARTNER_CODE: "Partner",
            VARIAZIONE: "Variation",
            AZIONI: "Actions"
        },
        PROCESSING: {
            ELABORAZIONE_IN_CORSO: "Processing in progress...",
            PREPARAZIONE: "Preparation...",
            ELABORAZIONE_ASSOCIAZIONI_CUSTOMERS: "Processing customer associations...",
            ELABORAZIONE_ASSOCIAZIONI_SHOPS: "Processing shop associations...",
            AGGIORNAMENTO_STATI_RELAZIONI: "Updating statuses and relations...",
            APPLICAZIONE_CONDIZIONI_CREAZIONE_LISTING: "Applying conditions and creating listings..."
        },
        UPLOAD_RESULTS: {
            RISULTATO_CARICAMENTO: "Upload result",
            NO_ROWS_ACCEPTED: "Since no row was processed correctly, no changes were made to the current exceptions.",
            SOME_ROWS_ACCEPTED: "You can view the result in the exceptions table on this page; some Excel rows may have been grouped for easier management and clarity. If you're satisfied with the result, simply save the business condition using the button in the top right!",
            EXCEPTIONS_CREATED: "Exceptions created:",
            ROWS_ERROR: "Rows with errors (discarded):",
            ROWS_WARNING: "Rows with warnings:",
            RIGA: "Row"
        }
    },
    PAGE_LISTING_EXCLUSION_RULES: {
        STATUS: {
            LABEL: {
                PENDING: "To be processed",
                PROCESSING: "In processing",
                CONFIRMED: "Confirmed",
                TO_BE_DEPRECATED: "To be deprecated",
                DEPRECATED: "Deprecated",
                TO_BE_DISABLED: "To be disabled",
                DISABLED: "Disabled",
                TO_BE_CANCELED: "To be canceled",
                CANCELED: "Canceled",
                TO_BE_ENABLED: "To be enabled"
                    },
            SHORT: {
                PENDING: "This rule is waiting for confirmation and activation.",
                PROCESSING: "This rule is currently being processed.",
                CONFIRMED: "This rule is confirmed and currently active.",
                TO_BE_DEPRECATED: "This rule is scheduled to be deprecated in the next processing.",
                DEPRECATED: "This rule is deprecated and no longer active.",
                TO_BE_DISABLED: "This rule is scheduled to be disabled in the next processing.",
                DISABLED: "This rule is currently disabled and not applied.",
                TO_BE_CANCELED: "This rule is scheduled to be canceled in the next processing.",
                CANCELED: "This rule is canceled.",
                TO_BE_ENABLED: "This rule is scheduled to be enabled in the next processing."
            },
            EXTENDED: {
                PENDING: "This rule is waiting for confirmation and activation.",
                PROCESSING: "This rule is currently being processed.",
                CONFIRMED: "This rule is confirmed and currently active.",
                TO_BE_DEPRECATED: "This rule is scheduled to be deprecated in the next processing.",
                DEPRECATED: "This rule is deprecated and no longer active.",
                TO_BE_DISABLED: "This rule is scheduled to be disabled in the next processing.",
                DISABLED: "This rule is currently disabled and not applied.",
                TO_BE_CANCELED: "This rule is scheduled to be canceled in the next processing.",
                CANCELED: "This rule is canceled.",
                TO_BE_ENABLED: "This rule is scheduled to be enabled in the next processing."
            }
        },
        PROCESSING: {
            ELABORAZIONE_IN_CORSO: "Processing in progress...",
            PREPARAZIONE: "Preparation...",
            ELABORAZIONE: "Processing rules...",
            APPLICAZIONE: "Applying rules...",
            FINALIZZAZIONE: "Setting final statuses and listing creation in progress..."
        },
        TABLE: {
            NOME: "Rule name",
            DATA_CREAZIONE: "Creation date",
            DATA_MODIFICA: "Update date",
            STATO: "Status",
            VAI_A_DETTAGLIO: "Go to details",
            DISABILITA: "Disable",
            CANCELLA: "Delete",
            RIATTIVA: "Reactivate",
            ANNULLA_OPERAZIONE: "Cancel operation",
        },
        TUTTE_LE_REGOLE_APPLICATE: "All the rules are applied.",
        DA_ELABORARE: "There are __COUNT__ rules to process.",
        REL_NON_COMPLETA: "This rule will not be applied because conditions have not been entered or the list of excluded shops has not been specified",
        CONFERMA_AVVIO_ELABORAZIONE: "Do you confirm the start of rule processing?",
        NUOVA_REGOLA: "New rule",
        AVVIA_ELABORAZIONE: "Start rule processing",
        TEST_REGOLE: "Run a test on the rules",
        REGOLE_ATTIVE: "Active rules",
        REGOLE_DA_ELABORARE: "Rules to be processed",
        REGOLE_DISABILITATE: "Disabled rules",
        REGOLE_CANCELLATE: "Deleted rules",
        REGOLE_IN_ELABORAZIONE: "Rules in processing",
        TAB_0: "Active / to be processed / disabled rules",
        CONFERMA_DISABILITA: "Do you confirm the deactivation of rule __NAME__?",
        CONFERMA_CANCELLAZIONE: "Do you confirm the deletion of rule __NAME__?",
        CONFERMA_ABILITA: "Do you confirm the activation of rule __NAME__?",
        CONFERMA_ANNULLAMENTO: "Do you confirm the cancellation of the operation in progress for rule __NAME__?",
        NOME: "Name",
        CONFERMA_SALVATAGGIO_REGOLA: "Do you confirm saving the changes made to the rule?",
        DATI_GENERALI: "General data",
        CONDIZIONI: "Conditions",
        SHOP_ESCLUSI: "Excluded shops",
        CLIENTI_ESCLUSI: "Excluded customers",
        CLIENTI_ESCLUSI_INFO: "In this section you can choose which customers to exclude from listings as defined in the rule you're editing.",
        AGGIUNGI_CLIENTI_ESCLUSI: "Add excluded customers",
        CONFERMA_ESCLUSIONE_CLIENTI: "Do you confirm the application of the exclusion to the selected customers?",
        CONFERMA_CANCELLAZIONE_ESCLUSIONE_CLIENTE: "Do you confirm the cancellation of the exclusion for the selected customer?",
        STORICO: "History",
        HISTORY: {
            NESSUN_ELEMENTO_DISPONIBILE: "No items available.",
            CREATE_GUI: "The rule was created in the CloudStore application.",
            CREATE_ENGINE: "The rule was created by the CloudStore rule engine during the step:",
            CREATE_API: "The rule was created via the CloudStore APIs.",
            UPDATED_GUI: "The rule was modified in the CloudStore application.",
            UPDATED_ENGINE: "The rule was modified by the CloudStore rule engine during the step:",
            UPDATED_API: "The rule was modified via the CloudStore APIs.",
            STEPS: {
                _0: "unknown",
                _1: "rule preparation",
                _2: "rule processing",
                _3: "rule application",
                _4: "final state setting and listing creation",
            }
        },
        EXCLUDED_SHOPS_INFO: "In this section you can choose which shops to exclude from listings as defined in the rule you're editing.",
        SELEZIONA_SHOP_ESCLUSI: "Select the shops to exclude",
        NUOVA_CONDIZIONE: "New condition",
        MODIFICA_CONDIZIONE: "Edit condition",
        SCARICA_TEMPLATE: "Download empty Excel template",
        SCARICA_CONDIZIONI: "Download Excel of configured conditions",
        CARICA_CONDIZIONI: "Upload Excel of conditions for this rule",
        CONDIZIONI_INFO: "In this section you can define the conditions under which the exclusion rule will be considered valid.",
        CONDITIONS: {
            SEASON: "Season",
            BRAND: "Brand",
            CATEGORY: "Category",
            SKU_PARENT: "SKU Parent",
            OPERATORE: "Operator",
            VALORE: "Value",
            CONFERMA_AGGIUNGI_A_CONDIZIONE: "Do you confirm adding the requested values to the condition?",
            CONFERMA_AGGIUNGI_A_CONDIZIONE_HELP: "The addition will not be saved automatically! You can still modify the conditions before saving.",
            VALORE_PRESENTE_IN_CLOUDSTORE: "This value is already present in some of the items in your inventory.",
            VALORE_NON_PRESENTE_IN_CLOUDSTORE: "This value is not yet listed in any of the items in your inventory.",
            NESSUN_VALORE_SELEZIONATO: "No value selected.",
            CATEGORIE_SELEZIONATE: "There are __COUNT__ selected categories. To view them, use the selector above.",
            ERRORE_CONDIZIONI_INCOMPLETE: (labels: string[]) => <>The following conditions are incomplete: <strong>{labels.join(", ")}</strong></>
        },
        UPLOAD_RESULTS: {
            RISULTATO_CARICAMENTO: "Upload result",
            NO_ROWS_ACCEPTED: "Since none of the uploaded conditions were valid, the current conditions remain unchanged.",
            SOME_ROWS_ACCEPTED: "You can view the upload result in the relevant boxes on this page.",
        }
    },
    PAGE_MODULES: {
        MODULI_ABILITATI: "Enabled Modules",
        MODULI_DISABILITATI: "Disabled Modules",
        NESSUN_MODULO_ABILITATO: "No enabled modules.",
        NESSUN_MODULO_DISABILITATO: "No disabled modules.",
        STATUS:{
            LABEL:"Status",
            ACTIVE:"Enabled",
            INACTIVE:"Not enabled",
            NOT_APPLICABLE: "Not applicable",
            PENDING: "Pending",
            VALIDATING: "Validating",
            CONFIRMED: "Confirmed",
            AUTH_ERROR: "Authentication error",
            ERROR: "Error",
        },
        TITLES: {
            BUSINESS_CONDITIONS: "Advanced pricing",
            BECOMMERCE: "BeCommerce",
            B2B: "B2B",
            POS: "POS",
            ERP: "ERP",
            FINANCE: "Finance",
            FxFF: "Fullfilment by Farfetch",
            WAREHOUSES: "Warehouses",
            NETSUITE: "NetSuite integration",
            MODULO_NON_SUPPORTATO: "Module not supported",
        },
        DESCRIPTIONS: {
            BUSINESS_CONDITIONS: "This module fully manages the pricing information of an item, both at the level of price lists and business conditions. It is possible to manage different price lists to be associated with Shops to define selling prices and discounted prices of each item, as well as to define business conditions reserved for both Shops (whether they represent retailers or not) and Customers who will purchase through the CloudStore B2B application.",
            BECOMMERCE: "Your E-Commerce powered by CloudStore.",
            B2B: "This application allows you to sell products from your catalog to B2B customers through the typical features of a sales channel, such as customer record management and order flow management. Compatible with PCs and tablets. Order creation: The module enables you to create orders from the catalog by adding items to the cart. The 'Orders from Showroom' feature is particularly interesting as it allows you to create an order during a guided visit in your showroom with an interface specifically optimized for mobile devices. Pre-orders: Give your customers the opportunity to create pre-orders which you can integrate and confirm, specifying discounts and quantities. Item card: The item card is designed to group variations of an item by specifying the variation attribute, thus facilitating the consultation of available quantities for each variation. Quick order: With one click, all available quantities of all catalog variations of an item will be added to the order. Customer records: Independently manage your customers' records by giving them access to the portal via username and password.",
            POS: "It is an application dedicated to Retail management that allows integrating a physical store into the CloudStore ecosystem through simple functionalities such as creating an order and managing customer records. It also allows monitoring of inventory levels in other stores/warehouses, thus providing the end customer with a complete experience.",
            ERP: "The ERP module is designed to provide specific functionalities dedicated to those who integrate their ERP with CloudStore through CloudStore APIs. It implements logic related to quantity updates, facilitates the retrieval of information such as warehouse movements related to orders, and prepares dedicated queues for communicating specific information (such as orders) in order to define a more precise flow and a more comprehensive relationship between the ERP and CloudStore.",
            FINANCE: "This module estimates the tax components on the prices indicated in orders lacking such information during the order receipt phase from shops. The estimate is made based on certain parameters defined by the user, particularly tax percentages and tax classes. Through the tax percentages, tax rates to be applied under certain conditions related to the geographical location of the order's shipping address are defined. Through the tax classes, tax classes to which the tax percentages are associated are defined. It is necessary to specify for each product in inventory the tax class to apply, in order to allow the calculation of the estimate.",
            FxFF: "The integration allows the management of Farfetch channels for which the Fulfillment by Farfetch (FxFF) service is active. During the creation of a Farfetch-type channel, it is possible to determine whether the FxFF service is active and in that case, it is necessary to specify the reference warehouse.",
            WAREHOUSES: "The warehouses module offers various functionalities and areas that the user can use to manage inventory and publication of articles on shops in a broader and customized manner. Warehouse records: List of warehouses used for which it is also possible to specify a client code and priority. Strategy: Various strategies are available that allow CloudStore to decide (or not) the picking warehouse for the goods following the arrival of an order. Advanced features: It will be possible to enable/disable warehouses on individual shops and/or enable/disable the warehouses on individual articles. In this way, it will be possible to customize the actual availability that you want to publish on a specific Shop.",
            NETSUITE: "This integration, optionally activatable in your CloudStore account, enables communication of CloudStore with your Oracle NetSuite account. The integration implements inbound and outbound data processes between the two accounts to synchronize customers, items, orders, billing data, shipping data, and warehouse movements. Synchronization in both directions is supported for various entities, depending on which of the two systems is the master of that specific information. Communication occurs through activity queues, processed by the CloudStore engine and consultable and verifiable through the user interface, through which the operator can reprocess unsuccessful communications. CloudStore interacts with NetSuite through its APIs, operating where possible directly with the CRUD of the involved entities, or obtaining information through saved searches. For the proper functioning of the integration and to manage a richer informational set than the base present in NetSuite, the integration uses Custom Field, Custom Record, and Custom List that must be configured in NetSuite (the configuration of these elements in the NetSuite account is entrusted to the Oracle technological partner of the Customer). The integration is highly customizable by the CloudStore Team through a rich set of configuration parameters and through custom code. To optimize performance, the processes of the integration are typically executed in parallel.",
        },
        B2B: {
            CONFIGURAZIONI_RELATIVE_AGLI_SHOP: "Configurations related to shops",
            ALTRE_CONFIGURAZIONI: "Other configurations",
            SHOP_PRIMARIO: "Primary shop",
            SHOP_SECONDARI: "Secondary shops",
            PASSWORD_EXCEL: "Password Excel",
            PASSWORD_EXCEL_INFO: "Password to open the Excel files generated in the B2B module",
            MODELLO_GESTIONE_PREZZI_DI_DEFAULT: "Default business price logic type",
            SMTP: {
                TITLE: "SMTP Server Configuration",
                INFO: "Configuration of the SMTP server used for sending emails to B2B customers.",
                ABILITATO: "SMTP Server Enabled",
                HOSTNAME: "Host Name",
                PORT: "Port",
                USERNAME: "Username",
                PASSWORD: "Password",
                SENDER: "Sender Address"
            },
            GESTIONE_PREORDINI: "Pre-order management",
            GESTIONE_PREZZI: "Price management",
            STATO_ORDINE_GENERATO_DA_PREORDINE: "Order status generated from pre-order",
            CUSTOMER_NELLO_SHOP: (shopName: string) => `Customer in the shop ${shopName}`,
            AGGIUNGI_CLIENTI: "Add customers",
            INFORMAZIONI_SALVATAGGIO_CUSTOMER_SHOP: "Customers added in this section will not be saved automatically: saving will occur by clicking the save button of the entire B2B module.",
            AGGIUNGI_SHOP_SECONDARI: "Add secondary shops",
            SHOPS: "Shops",
        },
        BECOMMERCE: {
            TABS: {
                AREE_GEOGRAFICHE: "Geographic Areas",
                SPESE_DI_SPEDIZIONE: "Shipping Costs",
            },
            NESSUNA_AREA_GEOGRAFICA_DEFINITA: "No geographic area defined.",
            AGGIUNGI_AREA_GEOGRAFICA: "Add geographic area",
            MODIFICA_AREA_GEOGRAFICA: "Edit geographic area",
            NOME_AREA: "Area name",
            NAZIONI_INCLUSE: "Included countries",
            ERRORE_NOME_AREA_GIA_UTILIZZATO: "Area name already used",
            ERRORE_COUNTRIES_GIA_UTILIZZATE: (countries: string[])=>`The following countries are already included in another geographic area: ${countries.join(", ")}`,
            NUMERO_NAZIONI_INCLUSE: (count: number)=>count===1?`1 included country`:`${count} included countries`,
            SELEZIONA_METODO_DI_SPEDIZIONE: "Select a shipping method",
            AGGIUNGI_RANGE_DI_PREZZO: "Add price range",
            MODIFICA_RANGE_DI_PREZZO: "Edit price range",
            DA_PREZZO: "From price",
            A_PREZZO: "To price",
            COSTO_SPEDIZIONE: "Shipping cost",
            GESTISCI_SOVRAPPOSIZIONE_RANGE_DI_PREZZO: "Manage overlapping price ranges",
            GESTISCI_SOVRAPPOSIZIONE_RANGE_DI_PREZZO_INFO: "When this option is selected, in case of overlap, other existing price ranges will be adjusted to avoid conflicts.",
            ERRORE_RANGE_DI_PREZZO_SOVRAPPPOSTI: "Overlapping price ranges with other existing ones for the same shipping method",
            MINIMO_MAGGIORE_MASSIMO: "The minimum value must be less than the maximum value",
            CONFIGURAZIONE_GATEWAY_PAGAMENTO: "Payment gateway configuration",
            PAYPAL: "PayPal",
            PAYPLUG: "PayPlug",
            PAYPAL_BASE_URL: "Base URL PayPal",
            PAYPAL_CLIENT_ID: "Client ID PayPal",
            PAYPAL_SECRET: "Secret PayPal",
            PAYPLUG_BASE_URL: "Base URL PayPlug",
            PAYPLUG_KEY: "PayPlug Key",
            IS_LIVE: "Production environment",
            SHOP_DI_RIFERIMENTO: "Reference shop",
        },
        FINANCE: {
            CLASSE_TASSAZIONE_COSTI_SPEDIZIONE: "Tax class for shipping costs",
            TABS: {
                CLASSI_DI_TASSAZIONE: "Tax classes",
                ALIQUOTE_FISCALI: "Tax rates"
            },
            DATA_CREAZIONE: "Creation date",
            DATA_ULTIMA_MODIFICA: "Last update date",
            NOME: "Name",
            PERCENTUALE: "Percentage",
            NAZIONE: "Country",
            STATI: "States",
            POSTAL_CODE_RANGE: "Postal Code Range",
        },
        POS: {
            SHOP_ASSOCIATIONS:"Shop associations",
            IMPOSTAZIONI_APPLICAZIONE: "Application settings",
            DNS: "DNS",
            NOME_APP: "App name",
        },
        WAREHOUSES: {
            SELECT_ALGO: "Select Algorithm for warehouses module",
            ALGORITMO: "Algorithm",
            NONE :"None",
            NO_OP:"No operation",
            WHS_PRIORITY:"Warehouse Priority",
            TEMP_COMMIT:"Support warehouse",
            SHOP_DRIVEN:"SHOP DRIVEN",
        },
        NETSUITE: {
            STATO: "Status",
        },
        BUSINESS_CONDITIONS: {
            INBOUND_ORDER_PRICE_CHECK: "Check prices during order inbound",
        },
        ACTIVATE_MODULE:"Module activation",
        LAST_UPDATE_DATE:"Last update date",
        LAST_STATUS_UPDATE_DATE:"Last status update date",
        LAST_ERROR_MESSAGE:"Last error message",
        ENABLE_DISABLED:"Enable / disabled module",
        GENERAL_CONFIG: "General configurations",
        UPDATE_CONFIRM: (module: string) => `You want to continue with the update of the ${module} module?`,
        ERROR_LOADING:"An error occurred while loading module, please try again or contact CloudStore support",
        LAST_RESTART_ATTEMPT_INDEX: "Last restart attempt index",
        CONFIGURAZIONE: "Configuration",
    },
    PAGE_PACKAGING: {
        SELEZIONA_UN_ORDINE: "Select an order",
        ERRORE_SUPERAMENTO_QUANTITA_GROUPAGE: "This order exceeds the maximum quantity allowed for this groupage.",
        CERCA_UN_ORDINE: "Search for an order...",
        SELEZIONA_UN_MAGAZZINO: "Select a warehouse...",
        SELEZIONA_UN_COMPUTER: "Select a printing computer...",
        SELEZIONA_UNA_STAMPANTE_ZEBRA: "Select a Zebra printer...",
        SELEZIONA_UNA_STAMPANTE_STANDARD: "Select a standard printer...",
        SELEZIONA_UNA_STAMPANTE_DI_SERVIZIO: "Select a service printer...",
        NESSUNA_STAMPANTE_ZEBRA_CONFIGURATA: "No Zebra printer configured",
        NESSUNA_STAMPANTE_STANDARD_CONFIGURATA: "No standard printer configured",
        NESSUNA_STAMPANTE_DI_SERVIZIO_CONFIGURATA: "No service printer configured",
        SELEZIONA_UN_MAGAZZINO_INFO: "To start, select a warehouse from the options in the top right.",
        LEGGI_UN_ARTICOLO: "Scan the barcode of an item to identify an order to process.",
        ARTICOLO_NON_TROVATO: "Item not found.",
        ARTICOLO_NON_IN_ORDINE: "The scanned item does not belong to this order.",
        ARTICOLO_COMPLETATO: "The scanned item has already been fully confirmed in this order.",
        ORDINE_GIA_COMPLETATO: "Packing of this order has already been closed for this warehouse.",
        ORDINE_SENZA_ARTICOLI_DA_INSCATOLARE: "This order has no items to pack in this warehouse.",
        ORDINE_NON_COMPLETAMENTE_CONFERMATO: "Not all the items of this order have been confirmed: packing cannot be closed.",
        ARTICOLO_IN_NESSUN_ORDINE: "No orders ready for packing were found containing this item.",
        ARTICOLO_IN_ORDINE_PACKAGED: "The item belongs to an order that has already been confirmed but not printed. Do you want to go to the order details page to proceed with printing?",
        ARTICOLO: "Item",
        MAGAZZINO: "Warehouse",
        SCATOLA: "Box",
        SELEZIONA_UNA_SCATOLA_ORDINE: "Select a box for the order",
        SELEZIONA_UNA_SCATOLA_RIGHE: "Select a box for each line of the order",
        QUANTITA_CONFERMATA: "Confirmed quantity",
        QUANTITA_RICHIESTA: "Requested quantity",
        SELEZIONA_UNA_SCATOLA: "Select a box...",
        SELEZIONA_SCATOLE: "Select boxes",
        CONFERMA_SCATOLA: "Confirm box",
        CHIUDI_LAVORAZIONE: "Close processing",
        CHIUDI_ORDINE: "Close order",
        STAMPA_TUTTI: "Print all",
        STAMPA_DI_SERVIZIO: "Service print",
        STAMPA_SINGOLA_SCHEDA_ARTICOLO: "Print single item sheet",
        STAMPA_TUTTE_LE_SCHEDE_ARTICOLO: (count: number) => `Print all item sheets (${count})`,
        RICHIESTA_CONFERMA_NO_SCATOLE: "You have not yet confirmed the box selection for this order",
        INFORMAZIONI_SULLO_STATO: "Status information",
        SCATOLA_CONFERMA_IN_CORSO: "Box confirmation in progress...",
        SCATOLA_CONFERMA_IN_CORSO_DESCRIPTION: "The confirmation of the selected box for this order is in progress, please wait.",
        SCATOLA_CONFERMATA_CORRETTAMENTE: "Box confirmed successfully",
        SCATOLA_CONFERMATA_CORRETTAMENTE_DESCRIPTION: "The selected box has been successfully confirmed for this order.",
        ERRORE_CONFERMA_SCATOLA: "Error confirming box",
        ERRORE_CONFERMA_SCATOLA_DESCRIPTION: "An error occurred while confirming the box for this order. Please try again.",
        VAI_DETTAGLIO_CODA: "Go to queue details",
        RIESEGUI_CONFERMA_SCATOLA: "Retry box confirmation",
        CONFERMA_RIESECUZIONE_CONFERMA_SCATOLA: "Are you sure you want to retry the box confirmation?",
        RICHIESTA_CONFERMA: "Before closing the processing of this order, check that you have printed the necessary documents.",
        CONFERMA_UNA_QUANTITA_PER_QUESTO_ARTICOLO: "Confirm a quantity for this item",
        CONFERMA_UNA_QUANTITA_ARTICOLO: (sku: string, shopOrderId: string) => <>Confirm a quantity for the item <span className="fw-bold">{sku}</span> in order <span className="fw-bold">{shopOrderId}</span>?</>,
        GROUPAGE: {
            ORDINI_IN_LAVORAZIONE: "Orders in progress",
            NESSUN_ORDINE_IN_LAVORAZIONE: "No orders in progress.",
            ORDINE_NON_IN_GROUPAGE_VUOI_AGGIUNGERE: "The order selected is not currently included in this groupage. Do you want to add it to the groupage?",
            ORDINE_NON_IN_GROUPAGE_VUOI_CREARE_GROUPAGE: "The order selected is not currently included in a groupage. Do you want to create a new groupage with this order?",
            CHIUDI_GROUPAGE: "Close groupage",
            ORDINI_LAVORABILI: "Workable orders",
            NESSUN_ORDINE_LAVORABILE: "No workable orders.",
            CONFERMA_CHIUSURA_GROUPAGE: "Before closing the processing of this groupage, check that you have printed the necessary documents.",
            IN_LAVORAZIONE: "In progress",
            COMPLETATO: "Completed",
            ERRORE_SPEDIZIONE_GIA_PRESENTE: "The destination groupage already has a shipment. Close the groupage processing before you can work on this order.",
            RIMUOVI_DAL_GROUPAGE: "Remove from groupage",
            CONFERMA_RIMOZIONE_DAL_GROUPAGE: (shopOrderId: string) => <>Remove order <span className="fw-bold">{shopOrderId}</span> from the groupage? The pieces already confirmed will be reset.</>,
            ERRORE_RIMOZIONE_SPEDIZIONE_GIA_PRESENTE: "The groupage already has a shipment: the order cannot be removed.",
        },
        PRINT_ERRORS: {
            TITLE: "The following errors occurred during printing:",
            GENERIC: "Generic",
            DOCUMENT_NOT_PDF: "The requested document is not a PDF",
            NO_PDF_AVAILABLE: "No PDF available for the requested document",
            ORDER_DOCUMENTS_MISSING: "The document is missing from the order",
            URL_NOT_FOUND: "Document URL not found",
            UNAUTHORIZED: "Unauthorized access to the document",
            CETTIRE_NO_ORDER: "Cettire order not confirmed and therefore unavailable for printing",
            NO_ORDER_ITEM_ID: "Order item ID not present",
            ZEBRA_PRINTER_NOT_AVAILABLE: "Zebra printer not available: document not printed on the Zebra",
            STANDARD_PRINTER_NOT_AVAILABLE: "Standard printer not available: document not printed on the standard printer",
            CONFIRM_ORDER_ITEM: "An error occurred while confirming the Cettire order line.",
            UNKNOWN_ERROR: "Unknown error",
            SERVICE: "Service print"
        },
        ZEBRA_ERRORS: {
            OK: "The printer is functioning correctly.",
            PAPER_OUT: "Paper missing or depleted",
            RIBBON_OUT: "Ribbon missing or depleted",
            MEDIA_DOOR_OPEN: "Door open",
            CUTTER_FAULT: "Cutter error",
            PRINTHEAD_OVERHEATING: "Printhead overheating",
            MOTOR_OVERHEATING: "Motor overheating",
            PRINTHEAD_FAULT: "Printhead error",
            INCORRECT_PRINTHEAD: "Incorrect printhead",
            PRINTER_PAUSED: "Printer paused",
            ERRORE_SCONOSCIUTO: "Unknown error. Check that the Zebra printer is powered on and properly connected."
        },
        CETTIRE: {
            PRENOTA_SPEDIZIONE: "Reserve shipment",
            PRENOTA_SPEDIZIONE_DISABILITATO: "To reserve a shipment on Cettire, you need to confirm all items for the selected warehouse.",
            NESSUNA_SPEDIZIONE_CREATA: "No shipment created.",
            INFORMAZIONI_SULLO_STATO: "Status information",
            ELEMENTO_CODA_NON_ANCORA_PRESENTE: "The corresponding queue entry has not yet been created.",
            PRENOTAZIONE_AVVENUTA_CORRETTAMENTE: "Reservation successful",
            PRENOTAZIONE_AVVENUTA_CORRETTAMENTE_DESCRIPTION: "The reservation of the shipment has been requested successfully.",
            PRENOTAZIONE_FALLITA: "Reservation failed",
            PRENOTAZIONE_FALLITA_DESCRIPTION: "the reservation of the shipment has failed. Below you can find the reason of the failure:",
            PRENOTAZIONE_IN_CORSO: "reservation in progress...",
            PRENOTAZIONE_IN_CORSO_DESCRIPTION: "The reservation of the shipment is in progress, please wait...",
            RIESEGUI_PRENOTAZIONE: "Restart reservation",
            VAI_DETTAGLIO_CODA: "Go to queue details",
            CONFERMA_RIESECUZIONE: "Are you sure you want to restart the shipment reservation process?"
        },
        MIINTO: {
            PRENOTA_SPEDIZIONE: "Reserve shipment",
            SELEZIONA_TIPO_SERVIZIO: "Choose service type",
            SELEZIONA_SERVIZIO: "Choose service",
            SELEZIONA_PUNTO_DI_RITIRO: "Choose pickup point",
            INFORMAZIONI_SULLO_STATO: "Status information",
            ELEMENTO_CODA_NON_ANCORA_PRESENTE: "The corresponding queue entry has not yet been created.",
            PRENOTAZIONE_AVVENUTA_CORRETTAMENTE: "Reservation successful",
            PRENOTAZIONE_AVVENUTA_CORRETTAMENTE_DESCRIPTION: "The reservation of the shipment has been requested successfully.",
            PRENOTAZIONE_FALLITA: "Reservation failed",
            PRENOTAZIONE_FALLITA_DESCRIPTION: "the reservation of the shipment has failed. Below you can find the reason of the failure:",
            PRENOTAZIONE_IN_CORSO: "reservation in progress...",
            PRENOTAZIONE_IN_CORSO_DESCRIPTION: "The reservation of the shipment is in progress, please wait...",
            RIESEGUI_PRENOTAZIONE: "Restart reservation",
            VAI_DETTAGLIO_CODA: "Go to queue details",
            CONFERMA_RIESECUZIONE: "Are you sure you want to restart the shipment reservation process?"
        }
    },
    PAGE_PRICEBOOKS: {
        AGGIUNGI_LISTINO: "New pricebook",
        SCARICA_TEMPLATE: "Download template",
        CARICA_LISTINI: "Upload pricebooks",
        TABLE: {
            NOME: "Name",
            CODICE: "Code",
            NAZIONI: "Countries",
            VALUTA: "Currency",
            NUMERO_ARTICOLI: "N° Items",
            VAI_A_DETTAGLIO: "Goto details",
            SCARICA_EXCEL: "Download Excel"
        }
    },
    PAGE_PRICEBOOK: {
        LISTINO_NON_TROVATO: "Pricebook not found",
        DATI_GENERALI: "General data",
        NAZIONI: "Countries",
        ARTICOLI: "Items",
        PREZZO: "Price",
        PREZZO_SCONTATO: "Sale price",
    },
    PAGE_REPORTS: {
        REPORT_DA_PROCESSARE: (count:number)=>count===0?"No report to be processed":`${count} reports to be processed.`,
        REPORT_FALLITI: (count: number)=>count===0?"Congratulations! No report failed.":`${count} failed reports.`,
        VAI_A_DETTAGLIO: "Goto details",
        RIELABORA: "Process report again",
        TRACKING: "Process Tracking",
        VUOI_RIELABORARE_QUESTO_REPORT: "Are you sure you want to process this report again?",
    },
    PAGE_REPORT: {
        DETTAGLIO_REPORT: "Report details",
        REPORT_NON_TROVATO: "Report not found",
        INFORMAZIONI: "Info",
        ID_REPORT: "Report ID",
        NOME_REPORT: "Report name",
        CODICE_REPORT: "Report code",
        CREATO_IL: "Created at",
        AGGIORNATO_IL: "Updated at",
        CONFIGURAZIONE_REPORT_DEL: "Report configuration date",
        CONFIGURAZIONE: "Configuration",
        SCHEDULAZIONE: "Scheduling",
        NESSUNA_SCHEDULAZIONE: "No scheduling",
        DESTINATARI: "Recipients",
        NESSUN_DESTINATARIO: "No recipients",
        JSON: "JSON",
        DETTAGLI: "Details",
        COPIA_JSON: "Copy JSON",
        CAMBIA_VISUALIZZAZIONE: "Change view",
        INCLUDI_MAGAZZINI: "Include warehouses"
    },
    PAGE_RESERVATIONS: {
        AGGIUNGI_RISERVA: "Add reservation",
        ELIMINA_RISERVE: "Delete reservations",
        SCARICA_EXCEL: "Download Excel",
        MODIFICA_RISERVE_DA_EXCEL: "Edit reservations from Excel",
        BULK_UPLOAD_INFO: (navigateFunction: Function) =><>You can check the progress of your request by clicking <span className="cs-link" onClick={()=>navigateFunction()}>here</span>.</>,
        ARTICOLI: "__COUNT__ items",
        SELEZIONARE_SHOP_ARTICOLO: "Select shop and item",
        ARTICOLO_PLACEHOLDER: "Type parent SKU, barcode or SKU...",
        TABLE: {
            ARTICOLO: "Item",
            PREZZO: "Price",
            MAGAZZINO: "Warehouse",
            SHOPS: "Shops",
            QTY: "Qty",
            DATA_CREAZIONE: "Creation date",
            DATA_MODIFICA: "Modification date",
            QTY_RENDER: "__QTY__ of __WH_QTY__",
            SHOP_TOOLTIP: "Click to go to the shop page __SHOP_NAME__, alt+click to filter reservations for this shop",
            SKU_TOOLTIP: (sku: string)=>`Click to go to the parent SKU page ${sku}, alt+click to filter reservations for this SKU`,
            WH_TOOLTIP: "Press alt+click to filter reservations for this warehouse"
        },
        SHOP_ARTICOLO_VALIDI: "The selected shops and item are valid.",
        VALIDAZIONE_IN_CORSO: "Validation in progress...",
        NEW_RESERVATION_CHECK_ERRORS: {
            SHOP_NON_IN_BUCKETS: "The following shops do not belong to any of the buckets available to the user:",
            ARTICOLO_NON_TROVATO: "Item not found.",
            SKU_CON_BUCKET_MANCANTI: "The following SKUs are not available in some of the buckets used by the selected shops:",
            SKU_CON_SHOP_ESCLUSI: "The following SKUs have at least one of the selected shops among the excluded listings:",
            WHS_NON_DISPONIBILI: "No warehouses are available for the selected shops."
        },
        NEW_RESERVATION_RESULTS: {
            QUANTITA: "Requested quantity",
            RISULTATI: "Results",
            ESEGUITO: "Done",
            ERRORE: "In error",
            INFO: "No reservable quantity"
        },
        SELEZIONA_MASSIMA_QUANTITA_DISPONIBILE: "Reserve the maximum available quantity in the warehouse",
        ATTIVI_SE_SHOP_ARTICOLO_VALIDATI: "Activated once the shops and item have been selected and validated for the new reservation.",
        SELEZIONARE_MAGAZZINO_E_QUANTITA: "Select a warehouse and define the quantity to reserve.",
        SELEZIONARE_MAGAZZINO_MAX_QTY: "Select a warehouse; the maximum available quantity in it will be reserved."
    },
    PAGE_SETTINGS_REPORTS: {
        REPORT_DISABILITATO: ()=><>This report is <span className="fw-bold">disabled</span>. You can enable it by right-clicking and selecting the corresponding option.</>,
        REPORT_ABILITATO: ()=><>This report is <span className="fw-bold">enabled</span>. You can disable it by right-clicking and selecting the corresponding option.</>,
        ABILITA: "Enable",
        DISABILITA: "Disable",
        NUOVO_REPORT: "New report",
        MODIFICA_REPORT: "Edit report",
        SELEZIONA_TIPO_REPORT: "Choose report type...",
        FORMATO_DESTINATARI_HELP: ()=><><div className="mb-1">E' possibile inserire indirizzi email nei seguenti formati:</div><ul><li>john.doe@email.com</li><li>John Doe &lt;john.doe@email.com&gt;</li></ul></>,
        FORMATO_DESTINATARI_NON_CORRETTO: "At least one of the subscribers is in the wrong format",
        CAMPI_AGGIUNTIVI: "Custom fields",
        INFORMAZIONI_AGGIUNTIVE: "Additional info",
        INCLUDI_INFORMAZIONI_CATEGORIE: "Include categories information",
        INCLUDI_INFORMAZIONI_IMMAGINI: "Include image informations",
        INCLUDI_INFORMAZIONI_SHOP_ATTIVI: "Include active shops information",
        CONFERMA_CREAZIONE: "Confirm report creation?",
        CONFERMA_MODIFICA: "Confirm report changes?",
        CREAZIONE_AVVENUTA_CON_SUCCESSO: "Report successfully created",
        MODIFICA_AVVENUTA_CON_SUCCESSO: "Report successfully updated",
        MINUTI: "Minutes",
        ORE: "Hours",
        GIORNI: "Days",
        MESI: "Months",
        GIORNI_SETTIMANALI: "Days of week",
        RAGGRUPPA_PER_SKU_PARENT: "Group by SKU Parent",
        RAGGRUPPA_PER_SKU_PARENT_HELP: ()=><><div className="mb-1">It is possible to group items by SKU Parent:</div><ul><li>If the grouping is enabled, the report contains one row per SKU Parent;</li><li>If the grouping is disabled, the report contains one row per SKU.</li></ul></>,
        CONFERMA_ABILITAZIONE: "Do you confirm enabling this report?",
        CONFERMA_DISABILITAZIONE: "Do you confirm disabling this report?",
        CONFERMA_ELIMINAZIONE: "Do you confirm deleting this report?",
        TABLE: {
            TIPO_REPORT: "Report type",
            STATO: "Status",
            SCHEDULAZIONE: "Scheduling",
            DESTINATARI: "Subscribers",
            SHOP: "Shop",
            CAMPI_PERSONALIZZATI: "Custom fields",
        }
    },
    PAGE_SHOPS: {
        FILTERS: {
            CONFIRMED: "Confirmed",
            ERROR: "Error",
            AUTH_ERROR: "Authentication error",
            PENDING: "In processing",
            DISABLED: "Disabled",
            STATO_DI_ABILITAZIONE: "Enablement status",
            SOLO_ABILITATI: "Only enabled",
            SOLO_DISABILITATI: "Only disabled",
        },
        NUOVO_SHOP: "New Shop",
        TIPO_SHOP: "Shop type",
        NOME_SHOP: "Shop name",
        TABLE: {
            NOME: "Name",
            TIPO: "Type",
            STATO: "Status",
            ABILITATO: "Enabled",
            DISABILITATO: "Disabled",
            CODICE: "Code",
            VAI_A_DETTAGLIO: "Go to details",
            COPIA_ID: "Copy ID",
            COPIA_CUSTOMER_CODE: "Copy Customer code",
            COPIA_MERCHANT_ID: "Copy Merchant ID",
            COPIA_TOKEN: "Copy Token",
            COPIA_BEARER: "Copy Bearer Token",
            ATTIVA: "Activate shop",
            DISATTIVA: "Deactivate shop",
            CONFERMA_DISATTIVAZIONE_SHOP: "Confirm deactivation of shop __SHOP__?",
            CONFERMA_ATTIVAZIONE_SHOP: "Confirm activation of shop __SHOP__?",
            SHOP_ATTIVATO: "Shop __SHOP__ successfully activated.",
            SHOP_DISATTIVATO: "Shop __SHOP__ successfully deactivated.",
            MIINTO_API: "Miinto API",
            COPIA_URL: "Copy URL",
            COPIA_USERNAME: "Copy username",
            COPIA_PASSWORD: "Copy password",
            COPIA_X_API_KEY: "Copy x_api_key",
        },
        REPORT_DI_VALIDAZIONE: {
            TITLE: "Validation report",
            PASSI_DI_VALIDAZIONE: "Validation steps",
            LIVELLO: "Level",
            GRUPPO: "Group",
            MESSAGGIO: "Message",
        },
        AGGIORNA_QUANTITA_VISIBILI: {
            TITLE: "Update visible quantities",
            NESSUNO_SHOP_ABILITATO: "There are no enabled shops to run the update on.",
            CONFERMA_AGGIORNAMENTO_SINGLE: (name:string)=><>The available quantities will be updated for the shop <span className="fw-bold">{name}</span>. Continue?</>,
            CONFERMA_AGGIORNAMENTO: (count:number)=><>The available quantities will be updated for <span className="fw-bold">{count}</span> {count===1?"shop":"shops"}. Continue?</>,
            SI_SONO_VERIFICATI_ERRORI: "The following errors occurred:",
        }
    },
    PAGE_SHOP: {
        SEZIONI: {
            STATISTICHE_ESPOSIZIONE_CATALOGO: "Catalog exposure statistics",
            CONFIGURAZIONE: "Configuration",
            LISTING: "Listing",
            CATALOGO_ONLINE: "Online catalog",
            FUNZIONALITA_ATTIVE: "Active features",
            VALORI_ATTRIBUTI: "Attribute values",
        },
        DETTAGLIO_SHOP: "Shop details",
        TIPO_SHOP: "Shop type",
        NOME: "Name",
        CUSTOMER_CODE: "Customer code",
        CONFIGURAZIONI_GENERALI: "General configurations",
        CONFIGURAZIONI_SPECIFICHE: "Specific configurations",
        ALTRE_CONFIGURAZIONI: "Other configurations",
        ENDPOINT_PER_SCARICO_CATALOGO: "Catalog download endpoint",
        CREDENZIALI: "Credentials",
        LISTINO: "Pricebook",
        LISTINI: "Pricebooks",
        LISTINO_PIENO: "Full pricebook",
        LISTINO_SCONTATO: "Discounted pricebook",
        LISTINI_DI_DEFAULT: "Default pricebooks",
        ACCESS_KEY: "Access key",
        SECRET_KEY: "Secret key",
        BRAND_LABEL: "Brand label",
        SELLER_LABEL: "Seller label",
        SHIPPING_POINT: "Shipping point",
        GENERALE: "General",
        DEFAULT_CURRENCY: "Default currency",
        LISTING: "Listing",
        FLUSSI: "Streams",
        CONFIGURAZIONE_FLUSSI_E_LISTING: "Streams and listing configuration",
        STRATEGIA_MAGAZZINI: "Warehouse strategy",
        SOVRASCRIVI_CONFIGURAZIONE_ACCOUNT: "Override account configuration",
        STRATEGIA: "Strategy",
        CONFERMA_CREAZIONE: "Confirm shop creation?",
        CONFERMA_MODIFICA: "Confirm shop modifications?",
        CREAZIONE_AVVENUTA_CON_SUCCESSO: "Shop __NAME__ successfully created",
        MODIFICA_AVVENUTA_CON_SUCCESSO: "Shop __NAME__ successfully modified",
        TOKEN: "Token",
        CONFERMA_RIGENERAZIONE_TOKEN: "Do you confirm regenerating the token for this shop?",
        ORDER_PRICE: "Order price",
        CREDENZIALI_SHOP_API: "Shop API Credentials",
        CONTROLLO_PREZZI_RICEZIONE_ORDINE: "Price check in order inbound",
        API_CREDENTIALS: "API Credentials",
        SFTP_CREDENTIALS: "SFTP Credentials",
        OTHER_CONFIGURATIONS: "Other Configurations",
        LANGUAGES: "Languages to be published on the shop",
        CAMPI_TAG: "Tag fields",
        PUBLISH_ONLY_ITEMS_WITH_QUANTITY: "Publish only items with quantity",
        STATISTICHE_CATALOGO: "Catalog statistics",
        TOLLERANZA_ESPOSIZIONE_STATISTICHE_CATALOGO: "Catalog exposure statistics tolerance",
        CONTROLLO_ORDINI_PENDING: {
            TITLE: "Pending Orders Check",
            STATO_DI_ATTIVAZIONE: "Activation Status",
            TOLLERANZA: "Tolerance (in hours)",
            INVIO_EMAIL_CLIENTE: "Send Email to Customer",
            CONTROLLO_DISABILITATO_SE_INBOUND_ORDER_NON_ATTIVO: "Pending orders check cannot be enabled if order inbound is disabled."
        },
        OPZIONI_PER_VARIAZIONI: {
            TITLE: "Variations options",
            OPZIONI: "Options",
            DESCRIZIONI_IN_LINGUA: "Translated descriptions for options",
            NESSUNA_OPZIONE_SELEZIONATA: "No option selected",
            NESSUNA_LINGUA_SELEZIONATA: "No language selected",
        },
        CATALOG_EXPOSURE: {
            RIEPILOGO: "Summary",
            ULTIMO_AGGIORNAMENTO: "Last updated",
            VALORE_TOTALE: "Total value",
            QUANTITA_TOTALE: "Total qty",
            NUMERO_TAGLIE: "Size #",
            NUMERO_ARTICOLI: "Item #",
            DETTAGLI: "Details",
            DATE_FILTER: {
                DAL_PRIMO_DEL_MESE: "From first of month",
                ULTIMI_TRE_MESI: "Last 3 months",
                ULTIMI_SEI_MESI: "Last 6 months",
                ULTIMI_NOVE_MESI: "Last 9 months",
                ULTIMO_ANNO: "Last year"
            }
        },
        ACTIVE_FEATURES: {
            CONDIZIONE_COMMERCIALE: "Business condition",
            NESSUNA_CONDIZIONE_COMMERCIALE: "No business condition associated",
            NESSUNA_REGOLA_DI_ESCLUSIONE: "No exclusion rule associated",
            CONDIZIONE_COMMERCIALE_DESC: "Business condition associated with the Shop",
            ALTRI_SHOP_ASSOCIATI: "Other associated shops",
            CUSTOMER_ASSOCIATI: "Associated customers",
            ECCEZIONI_PRESENTI: "Existing exceptions",
            REGOLE_DI_ESCLUSIONE: "Exclusion rules",
            REGOLE_DI_ESCLUSIONE_DESC: "Exclusion rules associated with the Shop listing",
            NOME_CONDIZIONE_COMMERCIALE: "Business condition name",
            NOME_REGOLA: "Rule name",
            COPIA_ID: "Copy rule ID",
            ALTRI_SHOP_ESCLUSI: "Other excluded shops",
            CONDIZIONI: "Conditions",
            VAI_ALLA_REGOLA: "Go to exclusion rule",
        },
        ATTRIBUTE_VALUES: {
            NESSUN_ATTRIBUTO_CON_VALORI_SHOP: "No attributes with shop-specific values",
            SELEZIONA_ATTRIBUTO: "Select attribute...",
            SELEZIONA_ATTRIBUTO_INFO: "Select an attribute to view its values specific to this shop.",
            SELEZIONA_VALORE_PARENT: (parentAttribute: CloudStoreAttributeEnum) => `Select a value for the attribute ${parentAttribute}...`,
        },
        CHANNEL: {
            ERRORE_SALVATAGGIO: "An error occurred while saving the following shops: __SHOPLIST__"
        },
        PERSONAL_SHOP: {
            PRODUCT_CACHE: {
                FILTERS: {
                    SKU: "SKU",
                    SHOP_ITEM_ID: "Shop Item ID",
                },
                TABLE: {
                    SKU: "SKU",
                    SHOP_ITEM_ID: "Shop Item ID",
                    QTY: "Quantity",
                    PRICE: "Price",
                    SALE_PRICE: "Sale Price",
                    UPDATE_DT: "Update Date" 
                },
                CONTEXT_MENU: {
                    COPIA_SKU: "Copy SKU",
                    COPIA_SHOP_ITEM_ID: "Copy Shop Item ID"
                }
            },
        },
        MIINTO: {
            IDENTIFIER: "Identifier",
            SECRET: "Secret",
            LANGUAGES: "Languages",
            PRICEBOOKS: "Price lists",
            TOKEN: "Token",
            URL: "URL",
            USERNAME: "Username",
            PASSWORD: "Password",
            PRODUCT_CACHE: {
                FILTERS: {
                    MIINTO_ID: "Miinto ID",
                    MIINTO_ITEM_ID: "Miinto Item ID"
                },
                TABLE: {
                    MIINTO_ID: "Miinto ID",
                    MIINTO_ITEM_ID: "Miinto Item ID",
                    GTIN: "GTIN",
                    ITEM_GROUP_ID: "Item Group ID",
                    COLOR: "Color",
                    UPDATE_DT: "Update Date"
                },
                CONTEXT_MENU: {
                    MOSTRA_DETTAGLIO: "Show detail",
                    COPIA_MIINTO_ID: "Copy Miinto ID",
                    COPIA_MIINTO_ITEM_ID: "Copy Miinto Item ID"
                },
                DETTAGLI: {
                    TITLE: "Product details",
                    STYLE_ID: "Style ID",
                }
            }
        },
        AMAZON: {
            AMAZON_EUROPE: "Amazon Europe",
            MARKETPLACE: "Marketplace",
            CLIENT_ID: "Client ID",
            MERCHANT_ID: "Merchant ID",
            DEVELOPER_MERCHANT_ID: "Developer Merchant ID",
            DEVELOPER_MERCHANT_ID_DESC: "The Developer Merchant ID is an identifier required by Amazon for integration, but it is not always necessary. If it is not present in the integration documentation of the relevant Amazon marketplace, you can enter the same value as the Merchant ID.",
            COPIA_DA_MERCHANT_ID: "Copy from Merchant ID",
            CLIENT_SECRET: "Client Secret",
            REFRESH_TOKEN: "Refresh token",
            CONFERMA_RIMOZIONE_SHOP: "Confirm removal of marketplace __MARKETPLACE__?",
            SELEZIONARE_ALMENO_UN_MARKETPLACE: "Select at least one marketplace",
            IMPORTA_DATI_CLIENTE_ORDINI: {
                TITLE: "Import order customer data",
                DESC: ()=><div><p>This tool allows the user to upload and process the export file <span className="fw-bold">shipments managed by Amazon - fiscal invoicing</span> of Amazon orders exported from Seller Central.</p><p>The file's compliance will be analyzed before use.</p><p>During the upload, the operation results will be displayed until completion.</p></div>,
                ERRORE_FILE_NON_CONFORME_COLONNE_MANCANTI: (columns: string[])=> <span>The uploaded file is not compliant because the following columns are missing: <strong>{columns.join(", ")}</strong></span>,
                ERRORE_RIGA_CAMPI_OBBLIGATORI: (columns: string[])=>`Missing mandatory fields: ${columns.join(", ")}`,
                TOTALE_RIGHE: "Total rows in the file",
                RIGHE_VALIDE: "Valid rows",
                RIGHE_NON_VALIDE: "Non-valid rows",
                IMPORT_LOG: {
                    TEXT: {
                        IMPORT_AVVIATO: (startDate: string, endDate: string) => `Starting import for orders from ${startDate} to ${endDate}`,
                        SCARICO_ORDINI: ()=>"Downloading orders in progress...",
                        ORDINI_TROVATI: (count: number) => `Orders found in the system in the date range requested: ${count}`,
                        ERRORE_RIGA_ORDINE_DUPLICATO: (rowNumber: number, orderId: string) => `${rowNumber} KO: Order ${orderId} duplicated in the import file.`,
                        ERRORE_RIGA_NON_VALIDA: (rowNumber: number, message: string) => `${rowNumber}. Invalid row: ${message}`,
                        ERRORE_ORDINE_NON_TROVATO: (rowNumber: number, orderId: string) => `${rowNumber}. Order ${orderId} not found in the system.`,
                        ERRORE_SHIPPING_INFO: (rowNumber: number, orderId: string) => `${rowNumber} KO: Order ${orderId} error saving shipping information.`,
                        ERRORE_BILLING_INFO: (rowNumber: number, orderId: string) => `${rowNumber} KO: Order ${orderId} error saving billing information.`,
                        RIGA_OK: (rowNumber: number, orderId: string) => `${rowNumber} OK: Order ${orderId} updated successfully.`,
                        ORDINI_AGGIORNATI: (count: number) => `Orders updated successfully: ${count}`,
                        ORDINI_NON_AGGIORNATI: (count: number) => `Orders not updated: ${count}`,
                        FINE_IMPORT: ()=>"Import completed.",
                    },
                    HTML: {
                        IMPORT_AVVIATO: (startDate: string, endDate: string) => <>Starting import for orders from <strong>{startDate}</strong> to <strong>{endDate}</strong></>,
                        SCARICO_ORDINI: ()=><>Downloading orders in progress...</>,
                        ORDINI_TROVATI: (count: number) => <>Orders found in the system in the date range requested: <strong>{count}</strong></>,
                        ERRORE_RIGA_ORDINE_DUPLICATO: (rowNumber: number, orderId: string) => <><strong className="text-danger">{rowNumber} KO:</strong> Order <strong>{orderId}</strong> duplicated in the import file.</>,
                        ERRORE_RIGA_NON_VALIDA: (rowNumber: number, message: string) => <><strong>{rowNumber}.</strong> Invalid row: {message}</>,
                        ERRORE_ORDINE_NON_TROVATO: (rowNumber: number, orderId: string) => <><strong>{rowNumber}.</strong> Order <strong>{orderId}</strong> not found in the system.</>,
                        ERRORE_SHIPPING_INFO: (rowNumber: number, orderId: string) => <><strong className="text-danger">{rowNumber} KO:</strong> Order <strong>{orderId}</strong> error saving shipping information.</>,
                        ERRORE_BILLING_INFO: (rowNumber: number, orderId: string) => <><strong className="text-danger">{rowNumber} KO:</strong> Order <strong>{orderId}</strong> error saving billing information.</>,
                        RIGA_OK: (rowNumber: number, orderId: string) => <><strong className="text-success">{rowNumber} OK:</strong> Order <strong>{orderId}</strong> updated successfully.</>,
                        ORDINI_AGGIORNATI: (count: number) => <>Orders updated successfully: <strong>{count}</strong></>,
                        ORDINI_NON_AGGIORNATI: (count: number) => <>Orders not updated or in error: <strong>{count}</strong></>,
                        FINE_IMPORT: ()=><>Import completed.</>,
                    }
                },
                SCARICA_REPORT: "Download report"
            },
        },
        WINKELSTRAAT: {
            TIPO_CREDENZIALI: "Credentials type",
            CLIENT_ID: "Client ID",
            SECRET_ID: "Secret ID",
            X_API_KEY: "x_api_key",
            TOKEN_CHANNABLE: "Token Channable",
            PROJECT_ID_CHANNABLE: "Project ID Channable",
            SKU_PREFIX: "SKU Prefix",
            WEBHOOKS_TITLE: "Webhooks",
            WEBHOOKS: {
                SHIPMENT: "Shipment",
                SHIPMENT_TRACK: "Shipment track",
                RMA_ITEMS: "RMA items"
            },
            URL: "URL",
            USERNAME: "Username",
            PASSWORD: "Password",
            USA_ITEM_ID_COME_CODICE_ARTICOLO: "Usa item id come codice articolo",
        },
        DECATHLON: {
            PRODUCT_CACHE: {
                FILTERS: {
                    OFFER_ID: "Offer ID",
                    OFFER_SKU: "Offer SKU",
                    PRODUCT_SKU: "Product SKU",
                },
                TABLE: {
                    OFFER_ID: "Offer ID",
                    OFFER_SKU: "Offer SKU",
                    PRODUCT_SKU: "Product SKU",
                    QTY: "Qty",
                    PRICE: "Price",
                    UPDATE_DT: "Update date"
                },
                CONTEXT_MENU: {
                    MOSTRA_DETTAGLIO: "Show details",
                    COPIA_OFFER_ID: "Copy Offer ID",
                    COPIA_OFFER_SKU: "Copy Offer SKU",
                    COPIA_PRODUCT_SKU: "Copy Product SKU",
                },
                DETTAGLI: {
                    TITLE: "Product details",
                    CS_ITEM_ID: "CS Item ID",
                    CS_PARENT_SKU: "CS Parent SKU",
                    MIRAKL_SHOP_ID: "Mirakl Shop ID",
                    ORIGIN: "Origin"
                }
            }
        },
        GIGLIO: {
            USERNAME: "Username",
            PASSWORD: "Password",
            ENVIRONMENT: "Environment",
            SANDBOX: "Sandbox",
            PRODUCTION: "Production",
            INTEGRATED_TEST: "Integration Test"
        },
        ZALANDO: {
            CLIENT_ID: "Client ID",
            SECRET_ID: "Secret ID",
            ZSS_ATTIVO: "ZSS Enabled",
            ZFS_ATTIVO: "ZFS Enabled",
            CENTRI_LOGISTICI: "Logistic Centers",
            ID_ZALANDO: "Zalando ID",
            MAGAZZINO_CLOUDSTORE: "CloudStore Warehouse",
            PRODUCT_CACHE: {
                FILTERS: {
                    EAN: "EAN",
                    SKU: "SKU",
                    SIMPLE_ID: "Simple ID"
                },
                TABLE: {
                    EAN: "EAN",
                    SKU: "SKU",
                    SIMPLE_ID: "Simple ID"
                },
                CONTEXT_MENU: {
                    MOSTRA_DETTAGLIO: "Show details",
                    COPIA_EAN: "Copy EAN",
                    COPIA_SKU: "Copy SKU",
                    COPIA_SIMPLE_ID: "Copy Simple ID"
                },
                DETTAGLI: {
                    TITLE: "Product details",
                    OFFERS: "Offers",
                    ORIGIN: "Origin",
                    UPDATE_DT: "Update Date",
                    COUNTRY: "Country",
                    STOCK: "Stock",
                    PRICE_REGULAR: "Regular Price",
                    PRICE_DISCOUNTED: "Discounted Price",
                    STATUSES: "Statuses"
                }
            }
        },
        ITALIST: {
            PARTIAL_ORDER: "Enable partial order",
            API_KEY: "API key",
            STORE_KEY: "Store key"
        },
        CETTIRE: {
            USERNAME: "Username",
            PASSWORD: "Password",
            USER_ID: "User Id"
        },
        MIRAKL: {
            API_KEY: "API key",
            SHOP_ID: "Shop Id"
        },
        FARFETCH: {
            STORE_ID: "Store Id",
            SAFE_KEY: "Secret Key",
            GOT_TO_SHOP: "Shop details",
            MERCHANT_CODE: "Merchant Code",
            MERCHANT_CODE_EXIST: "Value already exists in another Farfetch",
            VPI_PORT_ERROR: "Port must be less than or equal to 65535",
            URL: "URL",
            USERNAME: "Username",
            PASSWORD: "Password",
            CONFERMA_AUTOMATICA_SCATOLA_SUGGERITA: "Automatic confirmation of the suggested box by Farfetch",
            CONFERMA_AUTOMATICA_SCATOLA_SUGGERITA_DISABLED: "This option is disabled when order inbound is not active.",
            CONFERMA_AUTOMATICA_SCATOLA_SUGGERITA_DESC: "After confirming the availability of the goods, CloudStore will automatically confirm the box suggested by Farfetch during the order submission, if present.",
            REST: {
                REST_API: "REST API",
                CONFIGURA_REST_API: "Configure REST API",
                CLIENT_ID: "Client ID",
                CLIENT_SECRET: "Client Secret",
                USERNAME: "Username",
                PASSWORD: "Password",
                PARTNER_ID: "Partner ID",
                USER_AGENT: "User agent",
                MERCHANT_UUID: "Merchant UUID"
            },
            VPI: {
                TITLE: "Vendor Provider Imagery",
                ENABLED: "Enable Vendor Provider Imagery",
                HOSTNAME: "Host name",
                PORT: "Port",
                USENAME: "Username",
                PASSWORD: "Password"
            },
            FXFF: {
                TITLE: "Fulfillment",
                ENABLED: "Enabled Fulfillment by Farfetch",
                LOGISTIC_CENTER: "Logistic Center",
                LOGISTIC_CENTER_IT: "Italy",
                LOGISTIC_CENTER_HK: "Hong Kong",
                LOGISTIC_CENTER_US: "United States"
            },
            SANDBOX: "Sandbox",
            B2B: "B2B",
            ROLE: "Role",
            TABLE_SEC: {
                TITLE: "List of connected secondary shops",
                NOME: "Shop name",
                CODICE: "Code",
                COPY_ID: "Copy Shop ID",
                SHOP_ID_COPY: "Shop id of __FF__ copy!",
                GOT_TO_SHOP: "Shop details"
            },
            PRIMARY_SHOP: "Primary Shop",
            BUSINESS_MODEL: "Business Model",
            DEFAULT: "Default",
            BID_ASK: "Bid / Ask",
            BUY_SELL: "Buy / Sell",
            QUESTO_SHOP_PRIMARIO: "This is a primary shop.",
            QUESTO_SHOP_SECONDARIO: "This is a secondary shop.",
            PRODUCT_CACHE: {
                FILTERS: {
                    SKU: "SKU",
                    BARCODE: "Barcode",
                    STORE_BARCODE: "Store Barcode",
                    CERCA_PER_SKU: "Search by SKU",
                },
                TABLE: {
                    ITEMID: "Item ID",
                    SKU: "SKU",
                    BARCODE: "Barcode",
                    STORE_BARCODE: "Store Barcode",
                    BRAND: "Brand",
                    PREZZI: "Prices",
                    PIENO: "Full",
                    SCONTATO: "Discount",
                    TAGLIA_STAGIONE: "Size / Season",
                    TAGLIA: "Size",
                    STAGIONE: "Season",
                    QUANTITA: "Quantity"
                },
                CONTEXT_MENU: {
                    MOSTRA_DETTAGLIO: "Show Details",
                    COPIA_ITEM_ID: "Copy Item ID",
                    COPIA_STORE_BARCODE: "Copy Store Barcode"
                },
                DETTAGLI: {
                    TITLE: (itemId: number, size: string)=>`Identifiers of product ${itemId.toString()} / ${size}`,
                    ALTRE_INFORMAZIONI: "Other info",
                    BARCODE: "Barcode",
                    PREZZO_PIENO: "Full price",
                    PREZZO_SCONTATO: "Discount price",
                    DATA_AGGIORNAMENTO: "Update date",
                    DIPARTIMENTO: "Department",
                    GENERE: "Gender",
                    SKU: "SKU",
                    NOME: "Name",
                    GRUPPO: "Group",
                    SCALA_TAGLIE: "Size range type",
                    STILE: "Style",
                    ORIGINE: "Origin"
                }
            }
        },
        SHOPIFY: {
            DISCLAIMER_LINGUA: ()=><div><strong>Warning!</strong> The list of languages to be published on the shop, if populated, must necessarily include the default language for this shop on Shopify.</div>,
            CONFIGURAZIONE_METAFIELD_PRODOTTO: "Metafield - Product configuration",
            CAMPO_CLOUDSTORE: "CloudStore field",
            METAFIELD_SHOPIFY: "Shopify metafield",
            TIPO: "Type",
            NAMEFIELD_SHOPIFY: "Namefield Shopify",
            DATA_TYPE_SHOPIFY: "Data type Shopify",
            NESSUNA_CONFIGURAZIONE: "No association defined.",
            NOTIFICA_CLIENTE_SPEDIZIONE_ORDINE: "Notify user when order is shipped",
            SHOP_NAME: "shop_name",
            TOKEN: "token",
            TIPO_AUTENTICAZIONE: "Authentication type",
            CREDENZIALI_LEGACY: "Legacy credentials",
            CREDENZIALI_SVILUPPATORE: "Developer credentials",
            CLIENT_ID: "Client ID",
            CLIENT_SECRET: "Client Secret",
            USA_SHOPIFY_MARKETS: "Use Shopify Markets",
            TITOLO_CATALOGO: "Catalog Title",
        },
        ZETTLE: {
            API_KEY: "Api key",
            CLIENT_ID: "Client ID",
            VAT_PERCENTAGE: "VAT Percentage"
        }
    },
    PAGE_WAREHOUSES: {
        NUOVO_MAGAZZINO: "New Warehouse",
        FILTRA_SYSTEM: "Show system-defined warehouses",
        FILTRA_USER: "Show user-defined warehouses",
        TABLE: {
            NOME: "Name",
            STATO: "Status",
            PRIORITA: "Priority",
            CODICE: "Code",
            DEFINITO_DA: "Defined by",
            VAI_A_DETTAGLIO: "Go to detail",
            COPIA_ID: "Copy ID",
            COPIA_CODICE: "Copy Code",
            ELIMINA: "Delete Warehouse",
            CONFERMA_RIMOZIONE_MAGAZZINO: "Do you confirm the deletion of the warehouse __WAREHOUSE__?",
            RIMOZIONE_MAGAZZINO_SUCCESS: "The warehouse __WAREHOUSE__ has been successfully deleted",
            ADDRESS_LINE: "Address",
            CITY: "City",
            PROVINCE: "Province",
            PROVINCE_CODE: "Province Code",
            POSTAL_CODE: "Postal Code",
            COUNTRY_CODE: "Country Code",
            MODIFY: "Modify Warehouse",
        },
        OPERATION_SUCCESS: "Warehouse saved successfully",
        OPERATION_ERROR: "Error saving warehouse"
    },
    PAGE_CUSTOMERS:{
        CUSTOMER_DETAILS: "Customer Details",
        COPIA_ID: "Copy ID",
        NEW_CUSTOMER: "New Customer",
        CUSTOMER: "Customer",
        RETURN: "Return",
        LOADING: "loading...",
        NOT_FOUND: "Customer not found",
        ON_ERROR: "on error",
        CREATION_DATE: "Creation Date",
        ORDINI_ULTIMO_ANNO: "Last year orders",
        ORDERS_MADE: "Orders placed in the period",
        UPDATED_DATE: "Updated Date",
        ORDER_DATE: "Order date",
        SHIPPING_ADDRESSES: "Shipping addresses",
        ADD_NEW_ADDRESS: "Add new address",
        MODIFY_ADDRESS: "Modify shipping address",
        SHIPPING_ADDRESSES_DEFAULT: "Default address",
        NETSUITE_INBOUND_TOOLTIP: "The NetSuite inbound customer is active, so most properties of this user cannot be modified.",
        ERRORE_NOMINATIVO: "Company name or first and last name must be present",
        ERRORE_TELEFONO: "Incorrect format (e.g., correct: +39123456789)",
        USA_COME_SPEDIZIONE: "Also use as shipping address",
        COPIA_DA_FATTURAZIONE: "Copy from billing",
        VAI_A_SCHEDA_CLIENTE: "Go to customer record",
        RESTA_NELLA_PAGINA: "Stay on the page",
        TABS:{
            INFORMAZIONI_GENERALI: {
                TITLE: "General Information",
                ANAGRAFICA: "Personal Information",
                CONTATTI: "Contacts",
                NOME: "First Name",
                COGNOME: "Last Name",
                RAGIONE_SOCIALE: "Company Name",
                CODICE_CLIENTE: "Customer Code",
                LINGUA: "Language",
                EMAIL: "Email",
                TELEFONO: "Phone",
                CELLULARE: "Mobile",
                PEC: "Certified Email"
            },
            FATTURAZIONE: {
                TITLE: "Billing",
                CODICI: "Codes",
                INDIRIZZO: "Address",
                PARTITA_IVA: "VAT Number",
                CODICE_FISCALE: "Tax Code",
                SDI: "SDI",
                NAZIONE: "Country",
                INDIRIZZO_1: "Address 1",
                INDIRIZZO_2: "Address 2",
                CITTA: "City",
                PROVINCIA: "Province",
                SIGLA_PROVINCIA: "Province Code",
                CODICE_POSTALE: "Postal Code"
            },
            SPEDIZIONE: {
                TITLE: "Shipping",
                INDIRIZZI_DI_SPEDIZIONE: "Shipping Addresses",
                NESSUN_INDIRIZZO_PRESENTE: "No shipping addresses are defined for this customer at the moment.",
                INFORMAZIONI_GENERALI: "General Information",
                INDIRIZZO: "Address",
                CONTATTI: "Contacts",
                AGGIUNGI_INDIRIZZO: "Add Address",
                MODIFICA_INDIRIZZO: "Edit Address",
                ALIAS: "Alias",
                NOME: "First Name",
                COGNOME: "Last Name",
                RAGIONE_SOCIALE: "Company Name",
                NAZIONE: "Country",
                INDIRIZZO_1: "Address 1",
                INDIRIZZO_2: "Address 2",
                CITTA: "City",
                PROVINCIA: "Province",
                SIGLA_PROVINCIA: "Province Code",
                CODICE_POSTALE: "Postal Code",
                EMAIL: "Email",
                TELEFONO: "Phone",
                CELLULARE: "Mobile",
            },
            CONDIZIONI_COMMERCIALI: {
                TITLE: "Commercial Conditions",
                CONDIZIONE_COMMERCIALE_ATTIVA: "Active Commercial Condition",
                STORICO: "History of Associated Commercial Conditions",
                NESSUNA_CONDIZIONE_COMMERCIALE_ATTIVA: "No active commercial condition for this customer.",
                NESSUNO_STORICO: "No data available.",
                ULTIMA_MODIFICA: "Last Modification",
                STATO: "Status",
                NUMERO_ECCEZIONI: "Number of Exceptions",
                PLACEHOLDER_CONDIZIONE_COMMERCIALE: (date: string, variant?: Variant, label?: string) => <div className='d-flex align-items-center justify-content-start'>
                    <span className='me-2'>Association Date:</span>
                    <span className='fw-bold me-2'>{date}</span>
                    <span className='me-2'>Current Association Status:</span>
                    <span className={`fw-bold text-${variant}`}>{label}</span>
                </div>,
            },
            ORDINI: {
                TITLE: "Orders",
                CONFIGURAZIONE_CONTROLLO_ORDINI_PENDING: "Check PENDING order configuration",
                TOLLERANZA: "Tolerance",
            },
            B2B: {
                TITLE: "B2B",
                GESTIONE_PREZZI: "Price Management Model",
                GESTIONE_PREZZI_INFO: (variation: string) => <div>If this information is not specified, the default price management model for the account <span className='fw-bold'>({variation})</span> will be applied.</div>,
                SHOP_DI_DEFAULT: "Default Shops",
                SALVATAGGIO_SHOP_DESCRIPTION: "Saving default shops must be done by clicking the appropriate button in this section.",
            },
            BECOMMERCE: {
                TITLE: "BeCommerce",
                METODI_DI_PAGAMENTO_ABILITATI: "Enabled Payment Methods",
                METODI_DI_SPEDIZIONE_ABILITATI: "Enabled Shipping Methods",
                BANK_TRANSFER: "Bank Transfer",
                PAYPAL: "PayPal",
                CREDIT_CARD: "Credit Card",
                CUSTOMER: "Customer Courier",
                DHL_EXPRESS: "DHL Express",
                VAI_A_BECOMMERCE: "Go to BeCommerce",
                CONFIGURAZIONE: "Configuration",
                INVIA_EMAIL_REGISTRAZIONE: "Send invitation email to register",
                INVIA_EMAIL_REGISTRAZIONE_CONFERMA: (email: string) => <>Are you sure you want to send the invitation to <strong>{email}</strong>?</>,
            },
            ACCOUNT: {
                TITLE: "Account",
                DESCRIPTION: () => <div>Actions performed in this section are applied <span className='fw-bold'>immediately</span>, without needing to save using the button in the top right.</div>,
                MODIFICA_UTENTE: "Edit Username",
                USERNAME: "Username",
                RESET_PASSWORD: "Reset Password",
                STATO_CLIENTE: "Customer Status",
                CLIENTE_ATTIVO: "Active Customer",
                CLIENTE_NON_ATTIVO: "Inactive Customer",
                ATTIVA_CLIENTE: "Activate",
                DISATTIVA_CLIENTE: "Deactivate",
                CONFERMA_USERNAME: (username: string) => <><div>You are about to change the username of this customer to</div><div className='fw-bold my-2'>{username}</div><div>Are you sure you want to proceed?</div></>,
                USERNAME_GIA_IN_USO: "This username is already in use by another customer.",
                CONFERMA_ATTIVAZIONE: "Are you sure you want to activate this customer?",
                CONFERMA_DISATTIVAZIONE: "Are you sure you want to deactivate this customer?",
                RESET_PASSWORD_DESCRIPTION: "By clicking on the button on the right, an email will be sent to the customer with instructions for resetting the access password.",
                INVIA_RICHIESTA: "Send Request",
                CONFERMA_RESET: "Are you sure you want to reset the password for this customer?"
            },
            REL: {
                TITLE: "Exclusion Rules",
                REGOLE_DI_ESCLUSIONE_DESC: "Exclusion rules associated with the customer",
                NESSUNA_REGOLA: "No exclusion rules are associated with this customer.",
                NOME_REGOLA: "Rule Name",
                SHOP_ESCLUSI: "Excluded Shops",
                CONDIZIONI: "Conditions",
                VAI_ALLA_REGOLA: "Go to exclusion rule",
                COPIA_ID: "Copy rule ID",
            }
        },
        STATUS :{
            ACTIVE:"Active",
            INACTIVE: "Inactive",
        },
        TABLE:{
            USERNAME:" User Name",
            NOMINATIVO: "Nominee",
            CODE :"Username / Customer Code",
            COUNTRY:"Country",
            STATUS:"Status",
            EMAIL:"Email",
            EMAILPEC:"Email pec",
            PHONE:"Phone Number",
            CELL:"Cell Number",
            ANAGRAFICA_CLIENTE: "Customer Record",
            BILLING_ADDRESS: "Billing Address",
            SHIPPING_ADDRESS: "Shipping Address",
            CF: "Tax Code",
            SDI: "SDI Code",
            VAT: "VAT Code",
            ADDRESS_LINE: "Address",
            CITY: "City",
            VAI_A_DETTAGLIO: "Go to detail",
            PROVINCE: "Province",
            PROVINCE_CODE: "Province Code",
            POSTAL_CODE: "Postal Code",
            COUNTRY_CODE: "Country",
            SWITCH_DESC: "The billing address matches the shipping address"
        },
        CONTACT_NAME:"Contact name",
        OPERATION_SUCCESS: "Customer saved successfully",
        OPERATION_ERROR: "Error saving customer",
        ATLEAST_1_STATUS:"At least one status must be selected",
        RESET_PWD_SUCCESS:"Password reset successful",
        CHANGE_STATUS_SUCCESS:"Customer status change successful",
        CONFIRM_DELETE_ADDRESS:"Delete address?",
        ADD_CUSTOMER_ADDRESS:"Add customer address",
        CUSTOMER_ADDRESS_LIST:"Customer's shipping address list",
        TEST_REL: {
            TITLE: "Test exclusion rules",
            SELEZIONA_UN_ARTICOLO_PER_VISUALIZZARE_LA_VISIBILITA: "Select an item to view its visibility in this shop based on the defined exclusion rules.",
            ARTICOLO_VISIBILE: "The item is visible in this shop.",
            ARTICOLO_NON_VISIBILE: "The item is not visible in this shop due to the following exclusion rules:",
            NESSUNO_SHOP_SELEZIONATO: "No shop selected for this application.",
        }
    },
    PAGE_WHS_MOVEMENTS: {
        FILTRO_AVANZATO: "Advanced Filter",
        NEW_MOVEMENTS: "New movements",
        SCARICA_TEMPLATE_MOVIMENTI:"Download template",
        CARICA_MOVIMENTI:"Update movement",
        CREATION_PROGRESS:"Movement creation in progress",
        CREATION_SUCCESS:"Movement creation in progress",
        CREATION_ERROR:"Error creating movement",
        TABLE: {
            DATE: "Date",
            ORDER: "Order",
            BRAND: "Brand",
            QUANTITY: "Quantity",
            TYPE: "Tipo",
            WAREHOUSE: " Warehouse",
            TAGS: "Tags",
            COPIA_ID: "Copy ID",
            COPIA_ID_ORDER: "Copy Order ID",
            COPIA_SKU: "Copy SKU",
            TYPE_ABSOLUTE:"Absolute",
            TYPE_DIFFERENTIAL:"Differential",
            SKU: "SKU",
        },
        ADD_WHR_MOVEMENTS:{
            TITLE: "New warehouse movements",
            SKU: "SKU",
            SKU_PLACEHOLDER: "insert SKU",
            WAREHOUSE :"Warehouse",
            WAREHOUSE_PLACEHOLDER: "Select Warehouse",
            TYPE_PLACEHOLDER: "Select Type",
            COLLEGA_MOVIMENTO_ORDINE: "Link movement to an order",
            COLLEGA_MOVIMENTO_ORDINE_TEXT: () => <>You can link the movement to an order. In this case, the movement will be of type <strong>differential</strong>, and the selectable quantity will depend on the amount available in the warehouse movements for the order.</>,
            DESCRIZIONI_QUANTITA: {
                CAMPI_OBBLIGATORI_NO_ORDINE: "Before setting a quantity, you must select the SKU, warehouse, and movement type.",
                CAMPI_OBBLIGATORI_ORDINE: "Before setting a quantity, you must select the SKU, warehouse, and order. When an order is linked, the movement type is always differential.",
                ASSOLUTO_NO_ORDINE: "For an absolute movement, the minimum settable quantity is 0.",
                DIFFERENZIALE_NO_ORDINE: "If the movement is differential, you can issue at most the quantity available in the selected warehouse for the selected item, and it's not possible to set the quantity to 0.",
                ORDINE_GIA_SODDISFATTO: "No new movements can be created for the selected order, as it has already been fully fulfilled.",
                ORDINE_NON_SODDISFATTO: (count: number) => `For the selected order and item, you need to create warehouse movements totaling ${count === 1 ? "one unit" : `${count} units`}. If the selected warehouse does not have sufficient stock, you can create additional movements later using different warehouses.`,
            }
        },
        DOWNLOAD_TEMPLATE_TITLE: "Instructions",
        DOWNLOAD_TEMPLATE_INFO: ()=><>
            <p>By clicking the button below, you will download the CSV template for bulk warehouse movements upload.</p>
            <p>The file consists of the following columns:</p>
            <ul>
                <li><strong>$op:</strong> operation to be performed. <strong>Mandatory with value INS.</strong></li>
                <li><strong>$rt:</strong> record type. <strong>Mandatory with value WHS-MOVEMENT.</strong></li>
                <li><strong>sku / item_id:</strong> SKU or item ID of the article. Choose one of the two headers and fill in with the corresponding values. <strong>Mandatory.</strong></li>
                <li><strong>whs_code / whs_id:</strong> warehouse code or ID. Choose one of the two headers and fill in with the corresponding values. <strong>Mandatory.</strong></li>
                <li><strong>qty:</strong> quantity moved. Can be negative or positive. <strong>Mandatory.</strong> If the value for <strong>absolute</strong> is <strong>true</strong>, then the value must be positive.</li>
                <li><strong>absolute:</strong> identifies if the movement is absolute (<strong>true</strong>) or relative (<strong>false</strong>). <i>Optional, default <strong>false</strong>.</i></li>
                <li><strong>tags:</strong> list of values separated by commas. Used to assign additional labels to the movement. <i>Optional.</i></li>
            </ul>
        </>,
        UPLOAD_MODAL:{
            TITLE:"Upload new warehouses movements",
            UPLOAD_SUCCESS:"Upload success"
        }
    },
    PAGE_SHIPMENTS :{
        ORDINI: "Orders",
        NESSUN_ORDINE_PRESENTE: "No order found.",
        SHIPMENT :"Shipment",
        NUOVA_SPEDIZIONE: "New Shipment",
        FILTRO_AVANZATO: "Advanced Filter",
        VAI_A_DETTAGLIO: "Goto details",
        APRI_ANTEPRIMA: "Show preview",
        COPIA_ID: "Copy ID",
        CONSULTA_INVIO_A_SHOP: "Check shipment sending to Shop",
        NESSUN_INVIO_TROVATO: "No shipment sending to shop found.",
        FILTERS: {
            ORDER_TYPE: "Order type",
            ORFRT: "Order N°"
        },
        TABLE: {
            ORDER: "Order",
            CARRIER: "Carrier",
            STATUS: "Status",
            TRACKING_NUMBER: "N° Tracking",
            SHIPPING_DATE: "Shipping Date",
            DELIVERY_DATE: "Delivery Date",
            DELIVERY_METHOD: "Delivery Method",
            VAI_A_DETTAGLIO: "Go to detail",
            COPIA_ID: "Copy ID",
            ORDER_POPUP_TITLE: "Orders ID",
            TRACKING_URL: "Tracking URL",
        },
        PREVIEW: {
            RECIPIENT_INFO: "Recipient Information",
            NAME : "Name",
            SURNAME : "Surname",
            SHIPMENT_INFO: "Shipment Information",
            COMPANY: "Company",
            BUYER: "Buyer",
            ADDRESS: "Address",
        },
        SPEDIZIONE_NON_TROVATA: "Shipment not found",
    },
    PAGE_CATALOG: {
        NUOVO_ARTICOLO: "New Item",
        SINCRONIZZA_PARENT_ITEM: "Synchronize parent items",
        SINCRONIZZA_PARENT_ITEM_CONFIRM: "Are you sure you want to start synchronizing the parent items?",
        ESTRAI_CATALOGO: "Extract catalog",
        ESTRAI_CATALOGO_CONFIRM: "Are you sure you want to start extracting the catalog?",
        ESTRAI_CATALOGO_SUCCESS: (navigateFunction: Function, isDesktop: boolean)=><>Extraction started successfully. {isDesktop && <>You can follow its execution in the <span className="cs-link text-decoration-underline" onClick={()=>navigateFunction()}>report area</span>.</>}</>,
        ESTRAI_CATALOGO_ALREADY_RUNNING: (navigateFunction: Function, isDesktop: boolean)=><>Extraction already in progress. {isDesktop && <>You can follow its execution in the <span className="cs-link text-decoration-underline" onClick={()=>navigateFunction()}>report area</span>.</>}</>,
        FILTRO_AVANZATO: "Advanced Filter",
        INSERIRE_TRE_CARATTERI_PER_CERCARE: "Enter at least three characters to search",
        SKU: "SKU",
        BARCODE: "Barcode",
        TITOLO: "Title",
        BRAND: "Brand",
        CATEGORIA: "Category",
        DISPONIBILITA: "Availability",
        FILTERS: {
            BRAND: "Brand",
            CATEGORIE: "Categories",
            STAGIONI: "Seasons",
            CANALE_DI_VENDITA: "Sales Channel",
            QUANTITY: "Quantity",
            SELEZIONA_LE_CATEGORIE: "Select categories...",
            CATEGORIE_SELEZIONATE: "Selected categories"
        },
        SKU_GIA_ESISTENTE: "SKU already present in the catalog",
        EREDITA_PROPRIETA: "Inherit properties",
        VAI_A_ARTICOLO: "Go to item",
        COPIA_SKU: "Copy SKU",
        COPIA_BARCODE: "Copy barcode",
        COPIA_SKU_PARENT: "Copy parent SKU",
        COPIA_MNF_CODE: "Copy MNF code",
    },
    PAGE_EXPORT: {
        TIPO_EXPORT: "Export Type",
        UTENTE: "User",
        EXPORTERS: {
            CONDIZIONI_ECONOMICHE_SHOP: {
                TITLE: "Shop commercial conditions",
                SELEZIONA_SHOP: "Select shop",
                INCLUDI_IMMAGINI: "Include images",
                RIMUOVI_IMMAGINI_SOPRA_SOGLIA: "Remove images above this threshold (empty field = keep default)",
                IMMAGINI_RIDOTTE: "Reduced images",
                IMMAGINI_RIDOTTE_DESC: "For performance reasons, some images have been removed in this export."
            },
            CATALOGO: {
                TITLE: "Catalog",
                RAGGRUPPA_PER_SKU_PARENT: "Group by parent SKU",
                RAGGRUPPA_PER_SKU_PARENT_HELP: ()=><><div className="mb-1">It is possible to group items by parent SKU:</div><ul><li>If grouping is enabled, the export contains one row per parent SKU;</li><li>If grouping is NOT enabled, the export contains one row per SKU.</li></ul></>,
                CAMPI_AGGIUNTIVI: "Additional fields",
                INCLUDI_INFORMAZIONI_CATEGORIE: "Include category information",
                INCLUDI_IMMAGINI: "Include images",
                INCLUDI_INFORMAZIONI_SHOP_ATTIVI: "Include active shop information",
            }
        },
        NUOVO_EXPORT: "New export",
    },
    PAGE_ITEM: {
        DETTAGLIO_ARTICOLO: (sku_parent:string)=>`Details of item ${sku_parent}`,
        ARTICOLO_NON_TROVATO: (sku_parent:string, createFunction?: Function)=><>
            <div className="fs-5 text-center">No item with code <span className="fw-bold">{sku_parent}</span> has been found.</div>
            {createFunction && <div className="fs-6 mt-2 text-center">Do you want to create one? <span className="cs-link" onClick={()=>createFunction()}>Click here!</span></div>}
        </>,
        NUOVO_ARTICOLO: "Add a new item of this product",
        ARTICOLO_CORRENTE: "Current item",
        RIPARA_ERRORE: "Fix error",
        RIPARA_PROPRIETA: (label:string)=><div className="d-flex align-items-center justify-content-start"><span className="me-2">Fix property</span><span className="fw-bold">{label}</span></div>,
        SCEGLI_VALORE_VARIAZIONE: (label: string)=><span>Choose one of the following existing values and use it for variations that lack the property <span className="fw-bold">{label}</span>:</span>,
        VARIAZIONI_AGGIORNATE_SUCCESSO: (count: number)=>(count>1)?<span><span className="fw-bold">{count}</span> variations of this item have been updated successfully.</span>:<span><span className="fw-bold">One</span> variation of this item has been updated successfully.</span>,
        ERRORI_AGGIORNAMENTO: "The following errors have occurred",
        GESTISCI_TRADUZIONI: "Manage translations",
        TRADUCI_DA: (source:string) => <span>Automatically translate from: <span className="fw-bold">{source}</span></span>,
        TRADUZIONE_NON_DISPONIBILE: "Translation not available",
        SCELTA_TRADUZIONE_DESC: "Select the default language to display the item's language-specific properties.",
        AGGIUNGI_TRADUZIONE: "Add translation",
        TABS: {
            PANORAMICA: {
                TITLE: "Overview",
                DATA_ULTIMA_MODIFICA: "Last update date",
                CI_SONO_VARIAZIONI: (qty: number, onClick: Function)=>(qty===1)?<div>There is <span className="fw-bold cs-link" onClick={()=>onClick()}>one variation</span> of this item.</div>:<div>There are <span className="fw-bold cs-link" onClick={()=>onClick()}>{qty} variations</span> of this item.</div>,
            },
            DATI: {
                TITLE: "Data",
                GENERALI: "General",
                PERSONALIZZATI: "Custom",
            },
            IMMAGINI: {
                TITLE: "Images",
                COLLOCAMENTO: "Placement",
                POSIZIONE: "Position",
                SHOP_ESCLUSI: "Excluded shops",
                NESSUNO_SHOP_ESCLUSO: "No shop excluded",
                URL_MANCANTE: "The image URL is not available.",
                PRESENZA_IMMAGINE_VARIAZIONI_KO: (needed:number, actual: number)=><span>This image is available in <span className="fw-bold">{actual}</span> of <span className="fw-bold">{needed}</span> variations.</span>,
                SELEZIONA_IMMAGINE_PER_DETTAGLI: "Select an image on the left to view its details.",
                PERCORSO_IMMAGINE: "Image path",
                TUTTE_LE_VARIAZIONI: "Apply to all item variations.",
                VARIAZIONE: (sku: string)=>`Apply to variation ${sku}`,
                AGGIUNGI_IMMAGINE: "Add an image",
                ERRORE_VALORE_POS: "Position must be equals or greater than 1.",
                ERRORE_POS_DUPLICATA: "One of the selected variations already has an image in this position.",
                CONFERMA_ELIMINAZIONE: "Do you confirm the deletion of the selected image?",
            },
            AB: {
                TITLE: "Availability Buckets",
                AGGIUNGI_AB: "Add an Availability bucket",
                QUANTITA: "Quantity",
                PREZZI: "Prices",
                GENERALE: "General",
                SHOP_SPENTO: "This shop is offline",
                PREZZO: "Price",
            },
            VARIAZIONI: {
                TITLE: "Variations",
                SELEZIONA_VARIAZIONE: "Select a variation",
                AGGIUNGI_VARIAZIONI: "Add variations",
                SELEZIONA_ATTRIBUTO_VARIAZIONE: "Select the variation attribute",
                SELEZIONA_ATTRIBUTO_VARIAZIONE_DESC: "Select a variation attribute to add new variations of this article.",
                COLORE: "Colore",
                TAGLIA: "Taglia",
                COLORE_IN_LINGUA_DESC: (lang:string)=><>The language that will be used for the color is <span className="fw-bold ms-2">{lang}</span>.</>,
                ERRORE_SKU_GIA_PRESENTE: "SKU already present in the existing variations",
                ERRORE_SKU_GIA_PRESENTE_NUOVE_VARIAZIONI: "SKU duplicated in the new variations to be inserted",
                ERRORE_SIZE_GIA_PRESENTE: "Size already present in the existing variations",
                ERRORE_SIZE_GIA_PRESENTE_NUOVE_VARIAZIONI: "Size duplicated in the new variations to be inserted",
                ERRORE_COLORE_GIA_PRESENTE: "Color already present in the existing variations",
                ERRORE_COLORE_GIA_PRESENTE_NUOVE_VARIAZIONI: "Color duplicated in the new variations to be inserted",
            },
            ARTICOLI_COLLEGATI: {
                TITLE: "Linked items",
                AGGIUNGI_COLLEGAMENTO: "Add a link to an item",
                AGGIUNGI_COLLEGAMENTO_INFO: "In this section, you can link the selected variation to one or more different items.",
                TIPO_COLLEGAMENTO: "Link type",
                GIFT: "Gift",
                RELATED: "Related",
                QUANTITA: "Quantity",
                SHOP_ESCLUSI: "Excluded shops",
                ARTICOLO_NON_TROVATO: "Variation not found",
                ERRORE_ARTICOLO_UGUALE: "It is not possible to link a variation of an item to itself.",
                ERRORE_ARTICOLO_GIA_COLLEGATO: "The selected item variation is already linked.",
                VARIAZIONE: "Variation",
                SCOLLEGA: "Unlink item",
                VAI_A_ARTICOLO: "Go to item",
                CONFERMA_SCOLLEGAMENTO: "Do you confirm the deletion of the link with the selected variation?",
            },
            MAGAZZINI: {
                TITLE: "Warehouses",
                MAGAZZINO: "Warehouse",
                DISPONIBILITA: "Availability",
                QUANTITA_RISERVATE: "Reserved quantities",
            },
            DISPONIBILITA_PER_SHOP: {
                TITLE: "Availability per shop",
                SHOP: "Shop",
                DISPONIBILITA: "Availability",
                PREZZO: "Price",
            },
            MOVIMENTI_MAGAZZINO: {
                TITLE: "Warehouse movements",
                TABLE: {
                    DATE: "Date",
                    QUANTITA: "Quantity",
                    TIPO: "Type",
                    MAGAZZINO: "Warehouse",
                    TAGS: "Tags",
                },
                ASSOLUTO: "Absolute",
                DIFFERENZIALE: "Differential",
            },
            AGGIORNAMENTI_DISPONIBILITA: {
                TITLE: "Availability adjustments",
            },
            LISTINI: {
                TITLE: "Pricebooks",
                NOME_LISTINO: "Pricebook name",
                VARIAZIONI: "variations",
                TUTTE_LE_VARIAZIONI: "All variations",
                PREZZO: "Price",
            },
            CONDIZIONI_COMMERCIALI: {
                TITLE: "Business conditions",
                NOME_CONDIZIONE_COMMERCIALE: "Business condition name",
                VARIAZIONI: "Variations",
                TUTTE_LE_VARIAZIONI: "All variations",
                PREZZO: "Price",
            },
            GPSR: {
                TITLE: "GPSR",
                TITLE_EXTENDED: "General Product Safety Regulation",
            },
            CODICI_SHOP: {
                TITLE: "Shop codes",
                TIPO_SHOP: "Shop type",
                NOME_SHOP: "Shop name",
                CODICE_SHOP: "Shop code",
                CODICE_ARTICOLO_SHOP: "Item code in the shop"
            },
            IDENTIFICATIVI_ESTERNI: {
                TITLE: "External identifiers",
                IDENTIFICATIVO: "Identifier",
                VALORE: "Value",
                LABELS: {
                    EXTERNAL_ID: "External Code",
                    NS_INTERNAL_ID: "NetSuite identifier",
                    SHOP_INTERNAL_ID: "Shop Identifier"
                }
            },
            VISIBILITA_NEGLI_SHOP: {
                TITLE: "Shop visibility",
                SHOP: "Shop",
                VISIBILITA: "Visibility",
                VISUALIZZA_STORICO: "View history",
                VISIBILITA_PER_CUSTOMER_B2B: "Visibility for B2B customers",
                VISIBILITA_PER_CUSTOMER_BECOMMERCE: "Visibility for BeCommerce customers",
                VISIBILE: "Visible",
                NON_VISIBILE: "Not visible",
                VISIBILITA_PER_CUSTOMER: (shopName: string)=><span>Visibility for customer in shop <span className="fw-bold">{shopName}</span></span>,
                ARTICOLO_VISIBILE_PER_LO_SHOP_SELEZIONATO: ()=><span>Item is <span className="fw-bold text-success">visible</span> in the selected shop.</span>,
                ARTICOLO_NON_VISIBILE_PER_LO_SHOP_SELEZIONATO: ()=><span>Item is <span className="fw-bold text-danger">not visible</span> in the selected shop, caused by the following rules:</span>,
            }
        },
        ANALYSIS: {
            NESSUN_PROBLEMA_RILEVATO: "No issues detected.",
            ERRORS: {
                GENERIC: (entry: PropertyAnalysis)=><div><span className="fw-bold">{entry.field}</span> has an issue.</div>,
                TOTALLY_MISSING: (entry:PropertyAnalysis)=><div><span className="fw-bold">{entry.field}</span> missing in all the variations of the item.</div>,
                PARTIALLY_MISSING: (entry:PropertyAnalysis)=><div><span className="fw-bold">{entry.field}</span> missing in some of the variations of the item.</div>,
                PROPERTY_DIFFERENT: (entry:PropertyAnalysis)=><div><span className="fw-bold">{entry.field}</span> some variations of the item have different values from the main one: <span className="fw-bold">{((entry.additional_info?.less_frequent_values ?? []) as string[]).join(', ')}</span>.</div>,
                PROPERTY_NOT_DISTINCT: (entry:PropertyAnalysis)=><div><span className="fw-bold">{entry.field}:</span> some variations of the item share the following values: <span className="fw-bold">{((entry.additional_info?.more_frequent_values ?? []) as string[]).join(', ')}</span>.</div>,
                ABS_DIFFERENT: (entry:PropertyAnalysis)=><div><span className="fw-bold">Availability Buckets:</span> different among the variations of the item.</div>,
                ABS_PRICE_DIFFERENT: (_:PropertyAnalysis)=><div><span className="fw-bold">Availability Buckets:</span> different prices among buckets and shops.</div>,
            },
            DETAILS: {
                VALORE_CAMPO: (field: string) => `Value of field ${field}`,
                NUMERO_IMMAGINI: "Images count",
                BULLET_POINTS: "Bullet points",
                LOCALIZZATI: "Localized",
                NON_LOCALIZZATI: "Not localized",
                STATO: "Status",
                ERRORS: {
                    GENERIC: "Has an issue.",
                    TOTALLY_MISSING: "Missing value.",
                    PARTIALLY_MISSING: "Missing value.",
                    PROPERTY_DIFFERENT: "Value different from the main one.",
                    PROPERTY_NOT_DISTINCT: "Duplicate value.",
                    IMAGES_MISSING: "Missing images.",
                    BULLET_POINTS_MISSING: "Missing bullet points.",
                    ABS_DIFFERENT: "Availability buckets different from the majority of the variations.",
                    ABS_PRICE_DIFFERENT: "Different prices among buckets and shops.",
                }
            }
        },
        FIELD_NAMES: {
            SKU: "SKU",
            SKU_PARENT: "SKU Parent",
            MNF_CODE: "MNF Code",
            SEASON: "Season",
            SIZE: "Size",
            BRAND: "Brand",
            TITLE: "Title",
            DESC: "Description",
            MNF_EMAIL_ADDRESS: "Email address",
            MNF_NAME: "Name",
            MNF_POSTAL_ADDRESS: "Postal address",
            MNF_TRADEMARK: "Trademark",
            MNF_PRODUCT_DOCUMENT: "Product document",
            BARCODES: "Barcodes",
            BARCODE: "Barcode",
            EAN: "EAN",
            UPC: "UPC",
            BULLET_POINTS: "Other descriptions",
            CATEGORIE: "Categories",
            NESSUNA_CATEGORIA_PRIMARIA_SELEZIONATA: "No primary category selected.",
            NESSUNA_CATEGORIA_SECONDARIA_SELEZIONATA: "No secondary category selected.",
            COMPOSITION: "Composition",
        },
        SWITCHER: {
            CAMBIA_TIPO_CAMPO: "Change field type",
            TESTO_SEMPLICE: "Simple text",
            TRADUZIONI_SINGOLE: "Single translations",
        },
        COMPOSITION: {
            PERCENTUALE: "Percentage",
            MATERIALE: "Material",
            PARTE: "Part",
        },
        BULLET_POINTS: {
            TITLE: "Bullet points",
            APPLICA_LOCALIZZAZIONE: "Change to translations",
            ANNULLA_LOCALIZZAZIONE: "Cancel translation",
            CONFERMA_LOCALIZZAZIONE: "Confirm translation",
        }
    },
    PAGE_BINDINGS: {
        SELEZIONARE_UNO_SHOP: "Select a shop to get started",
        ATTRIBUTI_COMPLETAMENTE_ASSOCIATI: "Fully bound attributes",
        ATTRIBUTI_ASSOCIATI: "Bound attributes",
        SELEZIONARE_UN_ATTRIBUTO: "Select an attribute from the list",
        NUOVO_ATTRIBUTO: "Add a new attribute",
        NUOVA_REGOLA: "Add a new rule",
        REGOLE_PER_ATTRIBUTO: "Rules for the attribute",
        FILTRA_ASSOCIAZIONI_ATTIVE: "View already active bindings",
        INDOVINA_ASSOCIAZIONI: "Auto-fill bindings by attempting to deduce the shop values based on CloudStore values",
        RIPRISTINA_ASSOCIAZIONI: "Undo all current changes and restore bindings to their initial state",
        AGGIUNGI_ASSOCIAZIONE: "Add a binding by entering a CloudStore value that isn't present",
        SE_SI_VERIFICANO_CONDIZIONI: "If the following conditions are met",
        LE_ASSOCIAZIONI_SONO_LE_SEGUENTI: "The bindings are as follows",
        REGOLA_DEFAULT_NESSUNA_CONDIZIONE: "This is the default rule. No conditions can be added, bindings will always be active if no other rules are valid.",
        NESSUNA_CONDIZIONE: "No condition defined. Bindings are always valid.",
        BINDINGS_TABLE: {
            VALORE_CS: "CloudStore Value",
            VALORE_SHOP: "Shop Value"
        },
        CONFERMA_GUESS_BINDINGS: "The system will attempt to automatically fill in the shop values that are not yet bound based on the corresponding CloudStore values. Do you want to proceed?",
        CONFERMA_RIPRISTINO_BINDINGS: "If you proceed, all unsaved changes to the bindings will be lost.",
        TUTTI_GLI_SHOP_FARFETCH: "All Farfetch shops",
        ATTRIBUTO: "Attribute",
        NUMERO_VALORI_ASSOCIATI: "Number of values bound",
        VALORI_ASSOCIATI: (count:number)=>(count===1)?<>1 bound value</>:<>{count} bound values</>,
        NUOVA_ASSOCIAZIONE_DA_SALVARE: "This is a new binding to be saved",
        ASSOCIAZIONE_MODIFICATA_DA_SALVARE: "This binding has been modified and needs to be saved",
        SALVA_TUTTE: "Save all",
        HELP_ASSOCIAZIONE_ROOT: (shopName: string)=><>The associations defined below will be applied by default in <span className="fw-bold">{shopName}</span>. If you want to add a dependency from another attribute, click on the <i className="bi-plus-circle text-white mx-2" /> icon next to the attribute from which the associations should depend.</>,
        MODIFICA_ASSOCIAZIONI: "Edit bindings",
        MODIFICA_VALORI: "Edit values",
        GESTISCI_ASSOCIAZIONI: "Manage associations",
        GESTISCI_ASSOCIAZIONI_DERIVATE: "Manage derived associations",
        NESSUN_VALORE_CLOUDSTORE_TROVATO: "No CloudStore value available.",
        CONFERMA_ELIMINAZIONE: "Are you sure you want to delete this binding?",
        CONFERMA_ELIMINAZIONE_CON_FIGLI: "Are you sure you want to delete this binding with all his derived associations?",
        SALVA_TUTTE_LE_ASSOCIAZIONI: "Save all the changes",
        CONFERMA_SALVATAGGIO_MASSIVO: "Are you sure you want to save all the changes?",
        MOSTRA_TUTTI: "Show all",
        MOSTRA_ASSOCIATI: "Show bound",
        MOSTRA_NON_ASSOCIATI: "Show unbound",
        MOSTRA_INDOVINATI: "Show guessed",
        MOSTRA_NON_INDOVINATI: "Show not guessed",
        DUPLICA_ASSOCIAZIONI: "Duplicate bindings",
        DUPLICA_ASSOCIAZIONI_DISABILITATO: "To duplicate bindings there must be no ongoing changes.",
        DUPLICA_ASSOCIAZIONI_HELP: (attribute: string) =><>This feature allows you to choose which other categories to duplicate the bindings for the attribute <span className="fw-bold">{attribute}</span>. <br /> If a binding is already present for the selected category, it will be kept; otherwise, it will be added. <br />If it cannot be added, appropriate warnings will be displayed at the end of the operation.</>,
        CATEGORIE_DA_DUPLICARE: "Categories to duplicate to",
        RISULTATI_DUPLICAZIONE: "Duplication results",
        CREATI: "Created",
        IGNORATI: "Ignored",
        NON_TROVATI: "Not found",
        ERRORE_SCONOSCIUTO: "Unknown error",
    },
    PAGE_ORDERS: {
        TABLE: {
            CODICE_ORDINE: "Order code",
            CLIENTE: "Customer",
            STATO: "Status",
            DATA: "Date",
            NUMERO_ARTICOLI: "Items #",
            CONTROVALORE: "Total value",
            DOCUMENTI: "Documents",
            RIMBORSATO: "Refunded",
        },
        STATO_RIMBORSO: "Refund status",
        REFUNDED: "Only refunded",
        NOT_REFUNDED: "Exclude refunded",
        SELEZIONA_SPEDIZIONE: "Select shipment",
        CARRIER: "Carrier",
        SCARICA_ORDINI: "Download Orders",
        ORDINE: "Order",
        STATO_ORDINE: "Order status",
        DATA: "Date",
        CONTROVALORE: "Total value",
        NUMERO_ARTICOLI: "Items quantity",
        APRI_ANTEPRIMA: "Show preview",
        VAI_A_DETTAGLIO: "Go to details",
        COPIA_ID: "Copy ID",
        COPIA_CODICE_ORDINE: "Copy order code",
        INFORMAZIONI_ACQUIRENTE: "Buyer info",
        SPEDIZIONE: "Shipping",
        FATTURAZIONE: "Billing",
        ORDINI_TROVATI: "__COUNT__ orders found",
        STATUS_CHANGE: "Change order status",
        NESSUN_DOCUMENTO_PRESENTE: "No document available",
        NESSUN_CUSTOMER_PRESENTE: "No customer available",
        NESSUNA_SPEDIZIONE_PRESENTE: "No shipment available",
    },
    PAGE_AVAILABILITY_ADJUSTMENTS:{
        FILTERS: {
            MANDATORY_FILTERS: "You need to select a shop and an item to perform a search.",
        },
        TABLE:{
            DATE : "Date",
            SHOP : "Shop",
            SENT_QUANTITY: "Quantity sent",
            REASON: "Reason",
            STATE:"State",
            MESSAGE: "Message",
            COMPLETED :"Completed",
            INCOMPLETED: "Incompleted",
            LISTING: "Listing",
            MOVEMENT: "Movement",
            ORDER: "Order"
        },
        VAI_A_ARTICOLO: "Go to item",
        VAI_A_LISTING: "Go to listing",
        VAI_A_ORDINE: "Go to order",
        VISUALIZZA_MOVIMENTO_MAGAZZINO: "Show warehouse movement"
    },
    PAGE_ORDER: {
        ORDINE: "Order",
        DETTAGLIO_ORDINE: "Order details",
        ULTIMO_AGGIORNAMENTO: "Last update",
        NESSUN_PROBLEMA_RISCONTRATO: "This order has no problems.",
        PROBLEMI_RISCONTRATI: "There are some problems with this order.",
        IN_CARICAMENTO: "loading...",
        NON_TROVATO: "not found",
        IN_ERRORE: "in error",
        ORDINE_NON_TROVATO: "The order searched was not found.",
        ORDINE_IN_ERRORE: "There was an error in loading the order, please try again.",
        MENU: {
            SCARICA_EXCEL: "Download Excel",
            CONSULTA_NETSUITE: "Check the submission to NetSuite",
            INVIA_NETSUITE: "Send order to NetSuite",
            CONSULTA_ERP: "Check the submission to the ERP",
            INVIA_ERP: "Send order to the ERP",
            CONFERMA_INVIO_ORDINE_ERP: "Are you sure you want to send the order to the ERP?",
            CONFERMA_INVIO_ORDINE_NETSUITE: "Are you sure you want to send the order to NetSuite?",
            VAI_A_ELEMENTO_DELLA_CODA: "Go to queue entry",
        },
        PANORAMICA: "Overview",
        ARTICOLI: "Items",
        INFORMAZIONI: "Informations",
        DOCUMENTI: "Documents",
        NETSUITE: "NetSuite",
        METADATA: "Metadata",
        DATA: "Date",
        SKU: "SKU",
        ARTICOLO: "Item",
        BRAND: "Brand",
        QUANTITA: "Quantity",
        MODIFICA_QUANTITA: "Change quantity",
        PREZZO_UNITARIO: "Unit Price",
        PREZZO_TOTALE: "Total Price",
        DAZI: "Duties",
        SUBTOTALE: "Subtotal",
        TOTALE_ORDINE: "Order Total",
        SPESE_DI_SPEDIZIONE: "Shipping Costs",
        SCONTO: "Discount",
        MARKUP: "Markup",
        TIPO: "Type",
        MAGAZZINO: "Warehouse",
        TAGS: "Tags",
        ASSOLUTO: "Absolute",
        DIFFERENZIALE: "Differential",
        MOVIMENTI_MAGAZZINO: "Warehouse Movements",
        COPIA_ID_MAGAZZINO: "Copy Warehouse ID",
        COPIA_SKU: "Copy SKU",
        ID_MAGAZZINO_COPIATO: "Warehouse ID __WH__ copied!",
        UTENTE: "User",
        MODULO: "Module",
        SHOP: "Shop",
        AGGIORNAMENTI_DISPONIBILITA: "Availability adjustments",
        STATO: "Status",
        MESSAGGIO: "Message",
        NUOVO_DOCUMENTO: "New Document",
        DOCUMENTI_DI_TIPO: "Documents of Type",
        ELIMINA_DOCUMENTO: "Delete Document",
        STAMPA_DOCUMENTI_SELEZIONATI: "Print Selected Documents",
        SELEZIONA_PER_LA_STAMPA: "Right-click to select, left-click to remove",
        TIPO_DOCUMENTO: "Document Type",
        NESSUN_DOCUMENTO_DISPONIBILE: "No document available for this order.",
        ELIMINA_DOCUMENTO_CONFERMA: "Are you sure you want to delete the document?",
        DOCUMENTO_ELIMINATO: "Document successfully deleted",
        CARICAMENTO_IN_CORSO: "Loading...",
        NOME: "Name",
        EMAIL: "Email",
        ID: "ID",
        CHANGE_ORDER_SATUS:"Enter the new order status",
        CANCEL:"Cancel",
        CHANGE_STATUS:"Change status",
        CHANGE_STATUS_CONFIRM_MESSAGE: (status:string)=><div>Do you want to proceed with the status change to <span className="fw-bold">{status}</span>?</div>,
        CHANGE_STATUS_SUCCESS:()=><><div>Request successfully sent.</div><div>It may take a few seconds for the status change operation to be completed, so we ask you to check the result shortly.</div></>,
        SHIPPING_INFO: {
            NOME_AZIENDA: "Company Name",
            NOME: "First Name",
            COGNOME: "Last Name",
            CONTATTO_1: "Contact 1",
            CONTATTO_2: "Contact 2",
            VIA: "Street / Square / Other",
            NUMERO: "No.",
            CITTA: "City",
            CAP: "Postal Code",
            PROVINCIA: "Province",
            CODICE_PROVINCIA: "Province code",
            NAZIONE: "Country"
        },
        BILLING_INFO: {
            NOME_AZIENDA: "Company Name",
            NOME: "First Name",
            COGNOME: "Last Name",
            PARTITA_IVA: "VAT Number",
            CODICE_FISCALE: "Tax Code",
            PIVA: "VAT",
            CF: "Tax Code",
            CONTATTO_1: "Contact 1",
            CONTATTO_2: "Contact 2",
            VIA: "Street / Square / Other",
            NUMERO: "No.",
            CITTA: "City",
            CAP: "Postal Code",
            PROVINCIA: "Province",
            CODICE_PROVINCIA: "Province code",
            NAZIONE: "Country",
            ID_FATTURA: "Invoice ID",
            NUMERO_FATTURA: "Invoice Number",
            DATA_FATTURA: "Invoice Date",
            TOTALE_FATTURA: "Invoice Total",
            URL: "Url",
            METODO_PAGAMENTO: "Payment Method"
        },
        TAB_NETSUITE: {
            ID_ELEMENTO: "Item ID",
            CODICE_ESTERNO: "External Code",
            DATA_CREAZIONE: "Creation Date",
            DATA_ULTIMO_AGGIORNAMENTO: "Last Update Date",
            STATO: "Status",
            NUMERO_ESECUZIONI: "Number of Executions",
            NOME_SHOP: "Shop Name",
            ESEGUI_ELEMENTO: "Execute Item",
            INVIA_ORDINE: "Send Order to NetSuite",
            INVIA_ORDINE_CONFERMA: "Are you sure you want to send the order to NetSuite?",
            INVIA_ORDINE_ESEGUITO: "The order has been queued for sending to NetSuite.",
            INVIA_ORDINE_NON_ESEGUITO_GIA_ESECUZIONE: "The order is already queued for sending to NetSuite."
        },
        TAB_METADATA: {
            SELEZIONA_VERSIONE: "Select Version",
            CORRENTE: "Current",
            NESSUN_METADATO_DISPONIBILE: "No metadata available.",
            FINANCE_MODULE_DATA: "Finance Module Data",
            TAXES_SOURCE: "Tax Source",
            CALCOLATE_DALLO_SHOP: "Calculated by the shop",
            CALCOLATE_DA_CLOUDSTORE: "Calculated by CloudStore",
            TASSAZIONE_SPESE_DI_SPEDIZIONE: "Shipping Charges Taxation",
            TASSAZIONE_ARTICOLI: "Item Taxation",
            OPZIONI_DI_PROCESSAMENTO: "Processing Options",
            ORDINE_PARZIALE: "Partial Order",
            MAGAZZINI_SELEZIONATI_PER_SCARICO: "Warehouses Selected for Unloading",
            CONTROLLO_PREZZI_INBOUND_ORDER: "Inbound Order Price Check",
            PRICE_WARNING: "Price Warning",
            UNIT_PRICE_WARNING: "Unit Price Tax Excluded Warning",
            TOTAL_PRICE_WARNING: "Total Price Tax Excluded Warning",
            RIUSCITO: "Successful",
            NON_RIUSCITO: "Unsuccessful",
            ACCETTATO_DA_CLOUDSTORE: "Accepted by CloudStore",
            NON_ACCETTATO_DA_CLOUDSTORE: "Not Accepted by CloudStore",
            CONTROLLO_DISPONIBILITA_EFFETTIVA_ARTICOLI: "Actual Item Availability Check",
            ESITO: "Outcome",
            MESSAGGIO_DI_ERRORE: "Error Message",
            CATALOG_SNAPSHOT_DATA: "Catalog Snapshot Data",
            PREZZO_PIENO: "Stock Price",
            PREZZO_SCONTATO: "Sale Price",
            PENDING_ORDERS_CHECK_DATA: "Pending Orders Check Data",
            DATA_ULTIMO_MOVIMENTO_MERCI: "Date of last representative fullfillment",
            VALIDATION_DATA: "Validation Data",
            VALIDAZIONE_DISPONIBILITA: "Availability Validation",
            VALIDAZIONE_PREZZO: "Price Validation",
            QUANTITA_RICHIESTA: "# Requested",
            QUANTITA_DISPONIBILE: "# Available",
            QUANTITA_ACCETTATA: "# Accepted",
            RISULTATO: "Result",
            CONFIGURAZIONE: "Configuration",
            ESEGUITO: "Performed",
            STATO_ESECUZIONE: "Execution Status",
            OK: "Successful",
            KO: "Failed",
            NOT_APPLIED: "Not Applied",
            PRICE: "Price",
            TOTALPRICETAXEXCL: "Total Price (tax excl.)",
            UNITPRICETAXEXCL: "Unit Price (tax excl.)",
            TOTALPRICETAXINCL: "Total Price (tax incl.)",
            UNITPRICETAXINCL: "Unit Price (tax incl.)",
        },
        TAB_ACTIVITIES: {
            TITLE: "Activities",
            NESSUNA_ATTIVITA_DISPONIBILE: "No activities available for this order.",
            TITLES: {
                STATUS_HISTORY: (status: string, color: string)=><div className="d-flex align-items-center">Order status changed to <div className={`fw-bold text-${color} ms-1`}>{status}</div></div>,
                ACCETTAZIONE_ORDINE: "Order Acceptance",
                INVIO_ORDINE_ERP: "Send Order to ERP",
                INVIO_ORDINE_NETSUITE: "Send Order to NetSuite",
                INVIO_INFORMAZIONI_PACKAGING: "Send Packaging Information",
                INVIO_INFORMAZIONI_SPEDIZIONE: "Send Shipping Information",
                PRENOTAZIONE_SPEDIZIONE: "Booking Shipment",
                RICHIESTA_DOCUMENTO_SPEDIZIONE: "Request Shipping Document",
                TRANSAZIONE_DI_TIPO: (type: string)=><div>Transaction of type <span className={`fw-bold ${type==="PAYMENT"? "text-success" : "text-danger"}`}>{type}</span></div>,
                SPEDIZIONE: "Shipment",
            },
            MODIFICATO_DA: "Modified by",
            ARTICOLI: "Items",
            DATA_COMPLETAMENTO: "Completion Date",
            DURATA: "Duration",
            TIPO_DOCUMENTO: "Document Type",
            ID_TRANSAZIONE: "Transaction ID",
            IMPORTO: "Amount",
        },
        TAB_TRANSACTIONS: {
            TITLE: "Transactions",
            TABLE: {
                NESSUNA_TRANSAZIONE_DISPONIBILE: "No transactions available for this order.",
                DATA: "Date",
                TIPO_TRANSAZIONE: "Transaction Type",
                ID_TRANSAZIONE: "Transaction ID",
                STATO_TRANSAZIONE: "Transaction Status",
                IMPORTO: "Amount",
                METODO_PAGAMENTO: "Payment Method",
                GATEWAY: "Gateway",
            },
            CONTEXT_MENU: {
                COPIA_ID_TRANSAZIONE: "Copy Transaction ID",
                COPIA_ID_PAGAMENTO: "Copy Payment ID",
                CREA_UN_RIMBORSO: "Create a refund",
                MODIFICA_TRANSAZIONE: "Edit transaction",
                DETTAGLI_TRANSAZIONE: "Transaction details"
            },
            NUOVO_RIMBORSO: "New refund",
            INFORMAZIONE_RIMBORSO_GATEWAY: "When creating a refund for this transaction, a request will be sent to the corresponding payment gateway.",
            INFORMAZIONE_RIMBORSO_NO_GATEWAY: "When creating a refund for this transaction, it does not trigger an actual automatic refund.",
            IMPORTO_RIMBORSO: "Refund amount",
            RAGIONE_RIMBORSO: "Reason for refund",
            ERRORE_RIMBORSO_IMPORTO_ECCEDE_DISPONIBILE: (amountAvailable: string, amountRequested: string) => `The requested refund amount (${amountRequested}) exceeds the remaining refundable amount for this transaction (${amountAvailable}).`,
            RIMBORSO_IMPORTO_TOTALE: "Total refund amount",
            INFORMAZIONE_NESSUN_IMPORTO_RIMBORSABILE: "No refundable amount available for this transaction.",
            IDENTIFICATIVO_PAGAMENTO: "Payment ID",
            MOTIVO_TRANSAZIONE: "Transaction Reason",
            NOTE: "Notes",
            RIMBORSO_DEFINITO_ORDINE: "Refund is defined for the whole order",
            RIMBORSO_DEFINITO_RIGHE: "Refund is defined for specific order rows"
        },
        SALVATAGGIO_INFORMAZIONI_SPEDIZIONE_COMPLETATO: "Shipping information saved successfully!",
        SALVATAGGIO_INFORMAZIONI_FATTURAZIONE_COMPLETATO: "Billing information saved successfully!",
        INFORMAZIONI_AGGIUNTIVE: "Additional Information",
        NESSUNA_INFORMAZIONE_AGGIUNTIVA: "No additional information for this order.",
        DETTAGLI_ULTIMO_INVIO_A_NETSUITE: "Details of the last send to NetSuite",
        NESSUN_INVIO_A_NETSUITE: "No send to NetSuite available for this order.",
        NESSUN_ARTICOLO_PRESENTE: "No items in the order.",
        ARTICOLO_NON_PRESENTE: "Item not found in inventory.",
        APPLICA_A_SKU_STESSO_PARENT: "Apply to all variations of the same item in the order",
        ARTICOLO_NON_DISPONIBILE_NELLO_SHOP: "Item not available in the selected shop. Click to remove it from the order.",
        CONFERMA_RIMOZIONE_ARTICOLO: (sku: string) => `Are you sure you want to remove the item ${sku} from the order?`,
    },
    PAGE_CATEGORIES: {
        CATEGORIE_CLOUDSTORE: "CloudStore categories",
        ASSOCIAZIONI_SHOP: "Shops associations",
        NESSUNA_CATEGORIA_TROVATA: "No categories found",
        AGGIUNGI_CATEGORIA_ROOT: "Add root category",
        SELEZIONA_CATEGORIA: "Select a CloudStore category to view its associations with shops",
        NESSUNA_TRADUZIONE: "No translation",
        NESSUNA_ASSOCIAZIONE: "No association",
        NON_ASSOCIABILE: "Not associable",
        NUOVA_CATEGORIA: "New category",
        MODIFICA_CATEGORIA: "Edit category",
        ELIMINA_CATEGORIA_INFO: (name: string) =><><p>You are about to delete the category <strong>{name}</strong>.</p><p>The category CANNOT be deleted if there are items linked to it. Do you want to proceed?</p></>,
        MODIFICA_ASSOCIAZIONE: (shopName: string) => <>Update association for {shopName}</>,
        AGGIUNGI_ASSOCIAZIONE: (shopName: string) => <>Add association to {shopName}</>,
        ELIMINA_ASSOCIAZIONE: "Remove association",
        ELIMINA_ASSOCIAZIONE_INFO: (shopName: string, cloudStoreCategoryLabel: string, shopCategoryLabel: string) =><><p>you are about to remove the association for the shop <strong>{shopName}</strong> getween the Cloudstore category</p><p><strong>{cloudStoreCategoryLabel}</strong></p><p>and the shop category</p><p><strong>{shopCategoryLabel}</strong></p><p>Do you want to proceed?</p></>
    },
    PAGE_CATEGORY :{
        CATEGORY:"Category",
        TABS:{
            SUBCATEGORY:{
                TITLE:"Subcategory",
                SUBCATEGORY_OF:"Subcategory list of",
                SUBCATEGORY_NEW:"New SubCategory",
            },
            SHOPS:{
                TITLE:"Shops associations",
                NO_CAT_SHOP:"No mapping was found for the category",
                DELETE_CAT_TITLE:"Do you want to delete the selected category?",
                SELECT_CAT:"Select category",
                TITLE_CAT_SHOP:"Add news category association",
                ADD_NEW_CAT_SHOP: "Add news category association",
                SELECTED_CAT:"Category",
            },
            TRANSLATIONS:{
                TITLE:"Translations",
                TRANSLATION: "Traslation",
                COLUMNS : {
                    LANG:"Lingua",
                    TRANSLATION:"Traduzioni"
                },
                NEW_TRANSLATION:"Add new translation",
                NEW_LANGUAGE:"Select language",
                NEW_LANGUAGE_TO_ADD:"New language to add",
                NEW_TRANSLATION_ADD_CONFERMATION:"Are you sure you want to add the new translations?",
                REMOVE_TRANSLATION_CONFIRMATION:"Are you sure you want to delete the translation?",
                ADD_NEW_CAT_TRANSLATION: "Press the button to add news translations",
            }
        },
        SELECT_CAT_FROM_LIST: "Search or select category from the search menu",
        SEARCH_CAT_TITILE:"Serch categories",
        SEARCH_PLACEHOLDER:"At least 3 characters",
        ADD_CATEGORY:{
            TITLE: 'Add new category',
            NEW_CAT:'New category name',
            SUCCESS:"New category added successfully",
        },
        UPDATE_SHOP_CATEGORY:{
            TITLE: 'Browse the categories of the selected shop',
            SELECTED_CATEGORY:'Selected category',
            SELECTED_CATEGORY_NEW : 'Select new category',
        },
        REMOVE_CATEGORY: "Remove Category",
        REMOVE_CATEGORY_TEXT: "Warning: You are about to remove the category __CATEGORY__. Proceeding with this operation will delete both the category and all connected subcategories.",
        REMOVE_CATEGORY_SUCCESS:"Category __CATEGORY__ removal successful",
    },
    PAGE_SHOPS_WAREHOUSES_BINDINGS: {
        MAGAZZINI_NON_SELEZIONATI: "The following shops have no warehouse selected",
        CONFERMA_SALVATAGGIO_SENZA_RICHIESTA: ()=><><p>We are about to update the warehouse configuration; this operation involves recalculating the available quantities for the shop for which the warehouse configuration is being changed. The operation may take some time and can be monitored through long-running task queues.</p><p>At the same time, the bulk update procedure for quantities on the sales channel will be executed.</p></>,
        SALVATAGGIO_AVVENUTO_CORRETTAMENTE: "Configuration saved successfully",
        EVIDENZIA_RIGA: "Highlight this row",
        EVIDENZIA_COLONNA: "Highlight this column",
        SELEZIONA_RIGA: "Select this row (alt+click)",
        SELEZIONA_COLONNA: "Select this column (alt+click)",
        NOTIFY_SAVE_ERRORS: "The following errors occurred while performing the operation",
        SALVATAGGIO_SHOP: "Shop saving",
        RICALCOLO_QUANTITA: "Recalculate quantities",
        AGGIORNAMENTO_CANALI: "Sales channel update",
        NOME_SHOP: "Shop name",
        STEP: "Step",
        ERRORE: "Error"
    },
    PAGE_WAREHOUSES_MOVEMENTS: {
        WARNING_MANDATORY_FILTERS: "Select the date filter and at least one between the SKU and warehouse filters.",
        DETTAGLI_MOVIMENTO: "Movement details",
    },
    PAGE_RETURNS:{
        DETAILS: "Return details",
        RETURN:"Return",
        LOADING: "loading...",
        NOT_FOUND: "Not found",
        ON_ERROR: "on error",
        INFO: "Return information",
        ORIGIN_ORDER: "Origin order",
        REASON:"Reason",
        RESOLUTION:"Resolution",
        ITEMS: "Items",
        TABLE:{
            QUANTITY:"Quantity",
            STATUS:"Status",
            DATE:"Date",
            CREATION_DATE:"Creation date",
            ID:"Identifier",
            RETURN:"Return",
            CUSTOMER_CODE: "Customer code",
            UPDATE_DATE:"Update date",
            VAI_A_DETTAGLIO: "Goto details",
        }
    },
    PAGE_LOGS:{
        TRACKING:{
            TRACKING:"Tracking",
            ELEMENT_CREATION:"Element Creation",
            ELEMENT_PROCESSING: "Element Processing"
        },
        SETTINGS:{
            NEW_SETTINGS:"Add new configuraztion",
            FREQUENCY:"Frequency",
            SEARCH_TERM:"Search term",
            NO_SERCH_TERMS:"No serch terms",
            GROUP:"Group",
            LEVELS:"Levels",
            EMAILS: "Emails",
            COMPONENT:"Component",
            INSERT_MAILS: "Emails address",
            MODIFY_CONFIG:"Modify configuration",
            DELETE_CONFIG:"Delete configuration",
            DELETE_CONFIRM_MESSAGE:"Proceed to delete the activity log configuration",
            DELETE_CONFIRM:"Configuration removal successful",
        },
        WAREHOUSES_DETAILS:"Warehouse details"
    },
    PAGE_QUEUES:{
        SEARCH_TERM_PLACEHOLDER:"Search queue",
        FAVORITES:"Favorite",
        CORE:"Core queues",
        MODULE:"Module queues",
        EXTERNAL:"External queues",
        SEARCH_RESULTS:"Search results",
        RERUN_QUEUE:"Rerun queues",
        QUEUE_NOT_FOUND:"The requested queue was not found.",
        QUEUE_ERROR:"An error occurred while loading the queue, please try again.",
        QUEUE_EMPTY_BOX:"No items found for the selected queue",
        QUEUE_EMPTY_EXECUTIONS_DETAILS:"No executions were found for the specific queue",
        PANORAMICA: "Panoramica",
        NESSUNA_CODA_PREFERITA: ()=><>No favorites selected. To add queues to favorites click on the<i style={{padding:"3px", fontSize: "16px"  }} className=" bi-star text-primary"/>icon of the queue itself</>,
        NESSUNA_CODA_TROVATA: "No queue found.",
        CONFERMA_ESECUZIONE_ELEMENTI: (count: number) => (count === 1 ? `Do you confirm the execution of the selected item?` : `Do you confirm the execution of the ${count} selected items?`),
        ERRORE_ELABORAZIONE_ELEMENTI: (count: number) => (count === 1 ? `An error occurred while processing the selected item.` : `An error occurred while processing ${count} of the selected items.`),
        TABLE: {
            NOME: "Report name",
            CREATION_DATE:"Created at",
            UPDATE_DATE:"Updated at",
            GO_TO_DETAIL: "Go to detail",
            COPY_ID: "Copy ID",
            EXECUTIONS: "Executions",
            ATTIVITA: "Activities",
            STATUS: "Status",
            STATUS_ELABORATED:"Elaborated",
            STATUS_PENDING: "Pending",
            STATUS_TO_BE_PROCESSED: "To be processed",
            STATUS_PROCESSED_SUCCESSFUL:"Process completed",
            STATUS_PROCESSED_FAILED: "Process failed",
            RECORDS: "Records #",
            GOTO_DETAILS:"Go to details",
            RIESEGUI_ELEMENTO:"Execute again",
            EXTERNAL_CODE:"External code",
            VAI_A_FLUSSO_ORIGINE: "Go to source flow",
            ELEMENTI_ELABORATI_TOTALI: "Processed / Total items",
            COPIA_CODICE_ESTERNO: "Copy external code",
            SHOP: "Shop",
            SPEDIZIONE: "Shipment",
            MARKETPLACE: "Marketplace",
            SUBMISSION_ID: "Submission ID",
            SKU: "SKU",
            QUANTITA: "Qty",
            FILE: "File",
            ARTICOLO: "Item",
            TIPO: "Type",
            APPLICAZIONE_REGOLE_DI_ESCLUSIONE: "Application of exclusion rules",
            APPLICAZIONE_CONDIZIONI_COMMERCIALI: "Application of business conditions",
            ALLINEAMENTO_QUANTITA_CON_NETSUITE: "Quantity sync with NetSuite",
            SINCRONIZZAZIONE_FULL_PARENT_ITEMS: "Full Parent Items Synchronization",
            SINCRONIZZAZIONE_DIFFERENZIALE_PARENT_ITEMS: "Differential Parent Items Synchronization",
            LISTING_TIPO: (listing_type:ChildListingTypeEnum)=>{
                const listingTypeTheme = getListingTypeTheme(listing_type) ?? {type: listing_type, variant: "secondary"}
                return <>Listing of type <Badge className="smallest" bg={listingTypeTheme.variant}>{listing_type}</Badge></>
            },
            LISTING_TIPO_SU_ARTICOLI: (listing_type:ChildListingTypeEnum)=>{
                const listingTypeTheme = getListingTypeTheme(listing_type) ?? {type: listing_type, variant: "secondary"}
                return <>Listing of type <Badge className="smallest" bg={listingTypeTheme.variant}>{listing_type}</Badge> on items</>
            },
            LISTING_TIPO_SU_BUCKET: (listing_type:ChildListingTypeEnum, abName: string)=>{
                const listingTypeTheme = getListingTypeTheme(listing_type) ?? {type: listing_type, variant: "secondary"}
                return <>Listing of type <Badge className="smallest" bg={listingTypeTheme.variant}>{listing_type}</Badge> on bucket <span className="fw-bold">{abName}</span></>
            },
            LISTING_TIPO_SU_SHOP: (listing_type:ChildListingTypeEnum, shopRender: JSX.Element)=>{
                const listingTypeTheme = getListingTypeTheme(listing_type) ?? {type: listing_type, variant: "secondary"}
                return <span>Listing of type <Badge className="smallest" bg={listingTypeTheme.variant}>{listing_type}</Badge> on shop {shopRender}</span>
            },
            AGGIORNAMENTO_QUANTITA_DEDICATE: "Quantity update for a shop",
            AGGIORNAMENTO_QUANTITA_DEDICATE_A: (shopRender: JSX.Element)=>{
                return <span>Quantity update for the shop {shopRender}</span>
            },
            SHOP_DI_ORIGINE: "Source shop",
            SHOP_DI_DESTINAZIONE: "Destination shop",
            RESO_DI_ORIGINE: "Source return",
            ORDINE_DI_ORIGINE: "Source order",
            NS_INTERNAL_ID: "NS internal ID",
            NS_EXTERNAL_ID: "NS external ID",
            TOTALE: "Total",
            NOME_CLIENTE: "Customer name",
            CODICE_CLIENTE: "Customer code",
            SALES_ORDER: "Sales order",
            TRACKING_NUMBER: "Tracking number",
            UPC: "UPC",
            TRANSAZIONE: "Transaction",
            TIPO_ORDINE: "Order type",
            ID_PARTNER: "ID Partner",
            ORDINE: "Order",
            OPERAZIONE: "Operation",
            TIPI_OPERAZIONE: {
                UPDATE_ORDER_POSITION_STATUS: "Update order line status",
                BOOK_SHIPPING: "Book shipping",
                UPDATE_SHIPPING_DETAIL: "Update shipping details",
                FETCH_SHIPPING_DOCUMENT: "Retrieve documents",
                CREATE_RETURN: "Create return",
                UPDATE_RETURN_STATUS: "Update return status"
            },
            TIPI_DOCUMENTO: {
                ORDER_INFO: "Order description",
                RETURN_INFO: "Return description",
                LABEL_RETURN: "Return label",
                LABEL_SHIPPING: "Shipping label",
                LABEL_CHINA_SHIPPING: "China shipping label"
            },
            CODICE_ORDINE: "Order code",
            VEDI_ESITO_ELABORAZIONE: "View processing result",
            NESSUN_ESITO_DI_ELABORAZIONE_TROVATO: "No processing result found",
        },
        STATUS: {
            TO_BE_PROCESSED: "Pending",
            PROCESSING: "Processing",
            PROCESSED_SUCCESSFUL: "Processed",
            PROCESSED_FAILED: "Failed"
        },
        DETAILS: {
            TAB_INFO:"Information",
            TAB_INFO_TITLE_1:"Queue Information",
            TAB_INFO_TITLE_2:"Queue Execution",
            TAB_PAYLOAD:"Payload",
            TAB_DETAIL:"Detail",
            EXTERNAL_CODE:"External code",
            CREATION_DATE:"Creation date",
            UPDATE_DATE:"Last update date",
            STATUS:"Status",
            REPORT:"Report",
            TIMELINE_ELEMENT:"There is no information for this specific execution"
        },
        RIELABORA: "Process again",
        VUOI_RIELABORARE_QUESTO_ELEMENTO: "Are you sure you want to process this entry again?",
        METTI_IN_ELABORATO: "Set to Processed",
        VUOI_METTERE_IN_ELABORATO: (count:number) => (count === 1 ? `Are you sure you want to set the selected entry's status to Processed?` : `Are you sure you want to set the status of the ${count} selected entries to Processed?`),
        ALLEGATI: "Attachments",
        NESSUN_ALLEGATO_DISPONIBILE: "No attachments available.",
        STATO_AVANZAMENTO: "Progress status",
        STATO_AVANZAMENTO_NON_DISPONIBILE: "Progress status not available.",
        NON_ELABORATO: "Not processed",
        IN_ATTESA: "Pending",
        COMPLETATO: "Completed",
        NON_DISPONIBILE: "Not available",
        IN_ELABORAZIONE: "Processing",
        BUSINESS_CONDITIONS_PROGRESS_ELEMENTS: {
            PREPARAZIONE: "Preparation",
            ELABORAZIONE_ASSOCIAZIONI_CUSTOMERS: "Processing customer associations",
            ELABORAZIONE_ASSOCIAZIONI_SHOPS: "Processing shop associations",
            AGGIORNAMENTO_STATI_RELAZIONI: "Updating states and relationships",
            APPLICAZIONE_CONDIZIONI_CREAZIONE_LISTING: "Applying conditions and creating listing",
        },
        LISTING_EXCLUSION_RULES_PROGRESS_ELEMENTS: {
            PREPARAZIONE: "Preparation",
            ELABORAZIONE_AVAILABILITY_BUCKETS: "Processing availability buckets",
            AGGIORNAMENTO_REGOLE: "Updating rules",
            APPLICAZIONE_REGOLE_DI_ESCLUSIONE: "Applying exclusion rules",
        }
    },
    PAGE_LISTING: {
        DETTAGLIO_LISTING: "Listing details",
        VAI_AL_DETTAGLIO: "Go to details",
        FILTERS: {
            SHOP: "Shop",
            STATO: "Status",
            TIPO: "Type",
        },
        TABS: {
            DATI: "Data",
            ELENCO_ARTICOLI: "Items list",
            AGGIORNAMENTI_DISPONIBILITA: "Availability adjustments"
        },
        DATA: "Date",
        ORIGINE: "From",
        TEMPO_DI_ESECUZIONE: "Execution time",
        TIPO: "Type",
        STATO: "Status",
        LABEL_STATUS: (status:ChildListingStatusEnum) =>{
            if( status === "READY") {return "Ready"}
            if( status === "RUNNING") {return "Running"}
            if( status === "COMPLETED_WARNING") {return "Completed with warning"}
            if( status === "FAILED") {return "Failed"}
            if( status === "COMPLETED") {return "Completed"}
            return status as string
        },
        ARTICOLI: "Items",
        ARTICOLI_PUBBLICATI: "Published items",
        ARTICOLI_SCARTATI: "Discarded items",
        ARTICOLI_FALLITI: "Failed items",
        PASSAGGI: "Steps",
        NESSUN_PASSAGGIO_DISPONIBILE: "No steps found",
        TABLE_ITEMS: {
            SKU: "SKU",
            TITOLO: "Title",
            MARCA: "Brand",
            STATO: "Status",
            MESSAGGIO: "Message",
        },
        TABLE_AVAILABILITY_ADJUSTMENTS: {
            SKU: "SKU",
            DATA: "Date",
            SHOP: "Shop",
            QUANTITA: "Qty",
            STATO: "Status",
            MESSAGGIO: "Message",
        },
        PUBBLICATO: "Published",
        SCARTATO: "Discarded",
        FALLITO: "Failed",
        PRONTI: "Ready",
        PARENT_CONFERMATI: "Parent confirmed",
        PARENT_COMPLETATI_SENZA_FIGLI: "Parent completed without children",
        CONFERMA_RIPUBBLICAZIONE_LISTING: "Are you sure you want to process again this listing?",
        NEW_LISTING: {
            TITLE: "Create a listing",
            TIPO: "Listing type",
            MODALITA: "Mode",
            SHOP: "Shop",
            SHOP_DA_INCLUDERE: "Shops to be included",
            BUCKET: "Bucket",
            ITEM_TEXT_PLACEHOLDER: "Enter the codes using one of the following separators: space, newline, TAB, comma, semicolon, colon.",
            SEPARATORE: "Separator",
            SPAZIO: "Space",
            A_CAPO: "Newline",
            TAB: "TAB",
            VIRGOLA: "Comma",
            PUNTO_E_VIRGOLA: "Semicolon",
            DUE_PUNTI: "Colon",
            SCONOSCIUTO: "Unknown",
            VERIFICA_ARTICOLI: "Verify items",
            VERIFICA_ARTICOLI_DESC: "Select items to include in the listing and click Verify to validate them.",
            MOSTRA_SOLO_ARTICOLI_NON_VALIDI: "Show only invalid items",
            MOSTRA_TUTTI_GLI_ARTICOLI: "Show all items",
            QUESTO_VALORE_E_DUPLICATO: "This value is duplicated",
            CONFERMA_LISTING_SHOP: (listingType: string, shopNumber: number)=><>Confirm the creation of a listing <span className="fw-bold">{listingType}</span> on <span className="fw-bold">{shopNumber}</span> {shopNumber === 1?"shop":"shops"}?</>,
            CONFERMA_LISTING_SKU: (listingType: string, itemsCount: number)=><>Confirm the creation of a listing <span className="fw-bold">{listingType}</span> on <span className="fw-bold">{itemsCount}</span> SKU?</>,
            CONFERMA_LISTING_SKU_PARENT: (listingType: string, itemsCount: number)=><>Confirm the creation of a listing <span className="fw-bold">{listingType}</span> on <span className="fw-bold">{itemsCount}</span> SKU Parents?</>,
            OPERAZIONE_EFFETTUATA_SU_ARTICOLI_VALIDI: (validItemsCount: number, totalItemsCount: number)=><>The operation will be performed on <span className="fw-bold">{validItemsCount}</span> valid items out of <span className="fw-bold">{totalItemsCount}</span> total.</>,
            ERRORE_LISTING_SHOPS: (listingType: string, shopNames: string[]) => <>An error occurred during the creation of listing <span className="fw-bold">{listingType}</span> on {shopNames.length === 1?<>the shop <strong>{shopNames[0]}</strong>.</>:<> the shops <strong>{shopNames.map((name, index)=>`name${index === shopNames.length-1?"":", "}`)}</strong>.</>}</>
        }
    },
    PAGE_DAM: {
        NUOVO: "New DAM",
        MODIFICA: "Edit DAM",
        IMPOSTA_COME_PREDEFINITO: "Set as default",
        PREDEFINITO: "Default",
        USATI: "Used",
        LIBERI: "Free",
        TOTALI: "Total",
        ASSET_TOTALI: "Total assets",
        STATISTICHE: "Statistics",
        CONFIGURAZIONE: "Configuration",
        NOME: "Name",
        CUSTOMER_CODE: "Customer code",
        HOSTNAME: "Hostname",
        PORT: "Port",
        ENABLED: "Enabled",
        IS_DEFAULT: "Default",
        SECURE: "Secure",
        USERNAME: "Username",
        PASSWORD: "Password",
        REMOTE_UPLOAD_DIRECTORY: "Remote upload directory",
        EXPORTED_HTTP_URL_PREFIX: "Exported HTTP URL prefix",
        ERRORE_NOME_GIA_UTILIZZATO: "Name already in use.",
        STATO: "Status",
        PENDING: "Pending",
        CONFIRMED: "Confirmed",
        AUTH_ERROR: "Authentication Error",
        ERROR: "Error",
        CONFERMA_IMPOSTA_PREDEFINITO: (name: string) => <>Are you sure you want to set <strong>{name}</strong> as default?</>,
    },
    PAGE_USERS: {
        NUOVO_UTENTE: "New User",
        GRUPPI: "Groups",
        GROUPS: {
            TUTTI_GLI_UTENTI: "All Users",
            AMMINISTRATORI: "Administrators",
            AMMINISTRATORE: "Administrator",
            MASTER: "Master",
            FINANCE: "Finance",
            MAGAZZINIERI: "Warehousers",
            MAGAZZINIERE: "Warehouser",
            ATTIVI: "Active",
            ATTIVO: "Active",
            CANCELLATI: "Deleted",
            CANCELLATO: "Deleted",
            SOSPESI: "Suspended",
            SOSPESO: "Suspended",
            DA_CONFERMARE: "To be confirmed",
            IN_ERRORE: "In error",
        },
        NESSUN_UTENTE_SELEZIONATO: "No user selected.",
        DETTAGLI_UTENTE: "User details",
        MODIFICA_PASSWORD: "Change Password",
        INVIA_EMAIL_DI_RESET_PASSWORD: "Send Password Reset Email",
        TU: "You",
        CAMBIA_TIPO_UTENTE: "Change User Type",
        CONFERMA_CAMBIO_TIPO_UTENTE: (username: string, userType: string) => <>Are you sure you want to change the user type of <strong>{username}</strong> to <strong>{userType}</strong>?</>,
        CAMBIO_TIPO_UTENTE_EFFETTUATO: "User type changed successfully.",
        CAMBIO_TIPO_UTENTE_AVVISO: "The user type change will take effect at the next login. Do you want to log out now?",
        EFFETTUA_LOGOUT: "Log out",
        NON_ORA: "Not now",
        AVATAR: {
            MODIFICA_AVATAR: "Edit Avatar",
            MODIFICA_AVATAR_DESC: "Upload a file or drag it into the area below to edit it.",
            CLICCA_O_DROPPA_QUI: "Click here or drag the file...",
            DROPPA_QUI: "Drag the file here...",
        },
        EDIT_FORM: {
            USER_TYPE: "User Type",
            USERNAME: "Username",
            PASSWORD: "Password",
            CONFERMA_PASSWORD: "Confirm Password",
            FIRST_NAME: "First Name",
            LAST_NAME: "Last Name",
            COMPANY_NAME: "Company Name",
            WEBSITE: "Website",
            DEFAULT_LANG: "Default Language",
            CONFERMA_CREAZIONE_UTENTE: "Are you sure you want to create the new user?",
        }
    },
    TABLE: {
        PAGINA_NUMERO_DI: "Page __NUMBER__ of __TOTAL__",
        RISULTATI: "results",
        RISULTATI_FILTRATI_DA: "results (filtered from __TOTAL__ total)",
        VAI_A: "Go to...",
        PAGINA: "Page",
        NESSUN_RISULTATO: "No results.",
        SI_E_VERIFICATO_UN_ERRORE: "An error occurred. Click on the button below to retry."
    },
    DATE_PICKER: {
        DEFAULT_DATE_RANGES: {
            OGGI: "Today",
            IERI: "Yesterday",
            ULTIMA_SETTIMANA: "Last week",
            PRIMO_MESE: "From first of month",
            MESE_PRECEDENTE: "In previous month"
        },
        SALVA_FILTRO_PERSONALIZZATO: "Save custom filter",
        INTERVALLO_PERSONALIZZATO: "Custom ranges",
    },
    REACT_SELECT: {
        PLACEHOLDER: "Select a value...",
        RICERCA_IN_CORSO: "Searching...",
        DIGITARE_CARATTERI_RICERCA: (count:number) =>(count===1)?"At least one character is needed to search.": `At least ${count} characters are needed to search.`,
        NESSUN_RISULTATO: "No results found."
    },
    CONFIGURAZIONE: {
        NUOVA_CONFIGURAZIONE: "New Configuration"
    },
    FILTERS: {
        SELEZIONARE_ALMENO_UN_FILTRO: "Select at least one filter to view the results.",
        NESSUN_RISULTATO: "No results found.",
        ERRORE: "An error occurred, please try again."
    },
    ADVANCED_FILTERS: {
        FILTRO_AVANZATO: "Advanced filter",
        LABELS: {
            BRAND: "Brand",
            CATEGORIE: "Categories",
            STAGIONI: "Seasons",
            CANALE_DI_VENDITA: "Sales channel",
            QUANTITY: "Quantity",
            SELEZIONA_LE_CATEGORIE: "Select categories...",
            CATEGORIE_SELEZIONATE: "Selected categories",
            DATA: "Date",
            SKU: "SKU",
            STATO: "Status",
            ORDER_TYPE: "Order type",
            ORDER: "Order",
            ORDERS: "Orders in",
            WAREHOUSES: "Warehouses",
            SELEZIONA_MAGAZZINO: "Select a warehouse...",
            SELEZIONA_ELEMENTI: "Select items...",
            ELEMENTI_SELEZIONATI: "Selected items",
            COMPONENTS: "Components",
            GROUP: "Group",
            CUSTOMERS: "Customers",
            SHOP: "Shop",
            ARTICOLO: "Item",
            ARTICOLI: "Items included in",
            SEARCH: "Search term"
        },
        NESSUN_FILTRO_APPLICATO: "No filter applied.",
        ERRORE_CARICAMENTO_FILTRI: "An error occurred while loading the filters.",
        SHOP: "Shops in ",
        BRAND: "Brands in ",
        SEASON: "Seasons in ",
        E_ALTRI: " and others",
        E_ALTRE: " and others",
        DATA: "Date",
        DATA_DA: "from",
        DATA_A: "to",
        IL_GIORNO: "on the day",
        QUANTITA_NO: "DO NOT need to have available quantity",
        QUANTITA_SI: "must have at least one available quantity",
        FILTRI_PERSONALIZZATI: "Custom filters",
        NESSUN_FILTRO_PERSONALIZZATO: "No custom filters available.",
        SALVA_FILTRO_PERSONALIZZATO: "Save custom filter",
        SALVA_FILTRO_PLACEHOLDER: "Custom filter",
        APPLICA: "Apply",
        ANNULLA: "Cancel",
        RESETTA: "Reset",
        FILTRO_NON_APPLICATO: "Filter not yet applied",
        CATEGORIES: "Categories in",
        SKU: "SKUs in",
        QUALSIASI_STATO: "Any status",
        IN_STATO: "In status"
    },
    DOCUMENT_TYPES: {
        COMMERCIAL_INVOICE: "Invoice",
        AIRWAY_BILL: "Airway bill",
        RETURN_INSTRUCTIONS: "Return instructions",
        RETURN_LABEL: "Return labels",
        CITES_DECLARATION: "Washington Declaration",
        ORDER_DESCRIPTION: "Order description",
        SHIPPING_DESCRIPTION: "Shipping description",
        SHIPPING_LABEL: "Shipping labels",
        OTHER: "Other"
    },
    INPUT_TAGS:{
        ADD_TAGS:"Add a tag and press enter",
        REMOVE:"Click to remove",
        TITLE: "Tags"
    },
    AVAILABILITY_DETAILS: {
        TITLE: (shopName: string) =><>Availability details for <strong>{shopName}</strong></>,
        QUANTITA_PRESENTE_SHOP: "Quantity in the shop",
        QUANTITA_INVIATA_SHOP: "Quantity sent to the shop",
        QUANTITA_CALCOLATA: "Computed quantity",
        QUANTITA_DISPONIBILE_BUCKET: "Quantity available in the bucket",
        QUANTITA_DISPONIBILE_MAGAZZINI_ATTIVI: "Quantity available in the active warehouses",
        SITUAZIONE_MAGAZZINI: "Warehouse status at the moment the quantity is sent to the shop",
        TABLE: {
            MAGAZZINO: "Warehouse",
            QUANTITA: "Quantity",
            QUANTITA_RISERVATA: "Reserved quantity",
            ABILITATO_ARTICOLO: "Enabled on item",
            ABILITATO_SHOP: "Enabled on shop"
        }
    },
    QUEUES: {
        STATUSES: {
            TO_BE_PROCESSED: "Waiting",
            PROCESSING: "Processing",
            PROCESSED_SUCCESSFUL: "Successful",
            PROCESSED_FAILED: "Failed"
        },
        CARD:{
            ACCOUNT:"Account",
            SHOP:"Shop",
            AMAZON: "Amazon",
            BC:"Business Conditions",
            WHS:"Warehouses",
            ERP:"ERP Module",
            NETSUITE:"NetSuite",
            FXFF:"FXFF",
            TON:"Tony",
            RETAILPRO:"RetailPro",
            EFASHION:"e-Fashion",
            NEW_EXTERNAL:"New external queues",
            THE_CORNER:"The Corner",
            NEW_QUEUE:"New queues"
        },
        DESCRIPTIONS: {
            UNKNOWN_QUEUE: "Custom Queue",
            INTERNAL_QUEUE_IN_CLOUDSTORE: "Internal Queue in CloudStore",
            EXTERNAL_QUEUE_TO_CLOUDSTORE: "External Queue to CloudStore",
            ITEMS_TO_BE_PROCESSED: "Items to be processed",
            ITEMS_IN_ERROR: "Items in error",
            NO_ERROR: "No errors!",
            DEFAULT_DESCRIPTION: "There is no description available for the queue",
            OUTBOUND: {
                MOD_M2_PRICE_QUANTITY: {
                    LABEL: "Outbound prices and quantities",
                    DESCRIPTION: "Export of price and quantity information to the ESB."
                },
                MOD_M2_ITEMS: {
                    LABEL: "Outbound items",
                    DESCRIPTION: "Export of item registry information to the ESB."
                },
                TON_ITEM_NS: {
                    LABEL: "Outbound item",
                    DESCRIPTION: "Export of item registry from CloudStore to NetSuite"
                },
                SVT_ORDER: {
                    LABEL: "Outbound orders to Account Partner",
                    DESCRIPTION: "Outbound partner orders from Marketplace Account to Account Partner"
                },
                ERP_ORDERS: {
                    LABEL: "Outbound sales orders",
                    DESCRIPTION: "Sending of sales orders received from CloudStore to the connected ERP"
                },
                NS_OUTBOUND_SALES_ORDERS: {
                    LABEL: "Outbound sales orders",
                    DESCRIPTION: "Sending to NetSuite of sales orders received from CloudStore"
                },
                NS_OUTBOUND_TRANSFER_ORDERS: {
                    LABEL: "Outbound transfer orders",
                    DESCRIPTION: "Sending to NetSuite of transfer orders received from CloudStore"
                },
                OTHER_OUTBOUND_PACKAGES: {
                    LABEL: "Sending packaging information",
                    DESCRIPTION: "Sending of packaging information to Shops with this stream active",
                    EXTERNAL_KEY: "Order to be shipped",
                    PARTITON_ID:"Shop"
                },
                OTHER_OUTBOUND_SHIPMENTS: {
                    LABEL: "Sending shipments",
                    DESCRIPTION: "Sending of shipments to Shops with this stream active"
                },
                OTHER_OUTBOUND_RETURN: {
                    LABEL: "Sending returns without RMA",
                    DESCRIPTION: "Sending of information related to returns without RMA to Shops with this stream active"
                },
                OTHER_OUTBOUND_RETURN_REQUEST: {
                    LABEL: "Return request response",
                    DESCRIPTION: "Sending of the response to return requests to Shops with this stream active"
                },
                OTHER_OUTBOUND_ORDERS_CANCELLATION: {
                    LABEL: "Order cancellation update",
                    DESCRIPTION: "Update on the sales channel of a canceled order"
                },
                OTHER_OUTBOUND_REMOVE_ITEMS_RESULT: {
                    LABEL: "Remove items result",
                    DESCRIPTION: "Results of the item removal activities from the Shops"
                },
                AMZN_FEED_REQUEST_FULFILLMENT: {
                    LABEL: "Feed shipments",
                    DESCRIPTION: "Sending of shipment information"
                },
                AMZN_FEED_REQUEST_INVENTORY: {
                    LABEL: "Feed inventory",
                    DESCRIPTION: "Sending inventory item updates"
                },
                AMZN_FEED_RESPONSE: {
                    LABEL: "Feed response",
                    DESCRIPTION: "Reading Amazon's responses to various feeds"
                },
                TON_OUTBOUND_NS:{
                    LABEL: "Element outgoing to NetSuite",
                    DESCRIPTION: "Element outgoing to NetSuite"
                },
                MKPLSVT_SS_ORDER:{
                    LABEL:"Outbound Orders to SCSC",
                    DESCRIPTION:"Outbound Orders to SCSC",
                },
                MKPLSVT_ORDER:{
                    LABEL:"Outbound Orders to CS Connector",
                    DESCRIPTION:"Outbound Orders to CS Connector",
                },
                CORE_SHOP_MIINTO_ASYNC_REQUEST: {
                    LABEL: "Miinto async requests",
                    DESCRIPTION: "Dedicated queue for processing Miinto asynchronous requests"
                },
            },
            INBOUND: {
                TON_RP: {
                    LABEL: "Inbound warehouse movements",
                    DESCRIPTION: "Import of warehouse movements generated by Retail Pro"
                },
                EFASHION_ITEMS: {
                    LABEL: "Inbound items from eFashion",
                    DESCRIPTION: "Processing of items to be imported into CloudStore from eFashion"
                },
                NS_INBOUND_CASHSALE_INVOICE: {
                    LABEL: "Inbound invoices / receipts",
                    DESCRIPTION: "Import of information related to receipts and invoices"
                },
                NS_INBOUND_CUSTOMER: {
                    LABEL: "Inbound customers",
                    DESCRIPTION: "Import of customers who have access to the B2B module"
                },
                NS_INBOUND_FULFILLMENTS: {
                    LABEL: "Inbound shipments",
                    DESCRIPTION: "Import of information related to shipments"
                },
                NS_INBOUND_ITEM_AVAILABILITY: {
                    LABEL: "Inbound quantity updates",
                    DESCRIPTION: "Import of remaining available quantities of items"
                },
                NS_INBOUND_ORDERS: {
                    LABEL: "Inbound order updates",
                    DESCRIPTION: "Import of updates related to orders"
                },
                NS_INBOUND_ITEMS: {
                    LABEL: "Inbound items",
                    DESCRIPTION: "Import of item registries"
                },
                RP_INBOUND_MOVIMENTI: {
                    LABEL: "Inbound movements",
                    DESCRIPTION: "Import of warehouse movements created on Retail Pro"
                },
                OTHER_INBOUND_ITEMS: {
                    LABEL: "Import items",
                    DESCRIPTION: "Import of item registries"
                },
                OTHER_INBOUND_ITEM_IMAGES: {
                    LABEL: "Import item images",
                    DESCRIPTION: "Import of item images"
                },
                OTHER_BULK_INBOUND_ITEMS: {
                    LABEL: "Import items stream",
                    DESCRIPTION: "Mass import of item registry information"
                },
                OTHER_BULK_INBOUND_ITEM_IMAGES: {
                    LABEL: "Import item images stream",
                    DESCRIPTION: "Mass import of item images"
                },
                OTHER_BULK_INBOUND_WHS_MOVEMENTS: {
                    LABEL: "Import warehouse movements stream",
                    DESCRIPTION: "Mass import of warehouse movements"
                },
                OTHER_BULK_INBOUND_WHS_RESERVATIONS: {
                    LABEL: "Import warehouse reservations stream",
                    DESCRIPTION: "Mass import of warehouse reservations"
                },
                OTHER_INBOUND_WHS_MOVEMENTS: {
                    LABEL: "Import warehouse movements",
                    DESCRIPTION: "Import of warehouse movements"
                },
                RESERVATIONS: {
                    LABEL: "Import warehouse reservations",
                    DESCRIPTION: "Import of warehouse reservations"
                }
            },
            NETSUITE: {
                CONSULT_SEND_ORDER: "Consult the send to NetSuite",
                SEND_ORDER: "Send order to NetSuite",
                SEND_ORDER_NOT_AVAILABLE: "The order is already queued to be sent to NetSuite",
                SEND_ORDER_TITLE: "Order submission",
                SEND_ORDER_CONTENT_OK: "The order has been queued to be sent to <strong>NetSuite</strong>.",
                SEND_ORDER_CONTENT_KO: "It was not possible to prepare the order to be sent to <strong>NetSuite</strong>, or it is already queued to be sent."
            },
            OTHER: {
                REPORT: {
                    LABEL: "Report",
                    DESCRIPTION: "Processing of reports configured by the user"
                },
                LISTING: {
                    LABEL: "Listing",
                    DESCRIPTION: "Creation of listings for items subject to automatic publication"
                },
                LRT: {
                    LABEL: "Long-running tasks",
                    DESCRIPTION: "Queue processing long-running tasks",
                    TIPO_TASK: "Task Type",
                    TASK_TYPES: {
                        BUSINESS_CONDITIONS_APPLY: "Application of business conditions",
                        ITEM_QUANTITIES_RECALCULATION: "Recalculation of item quantities",
                        LISTING_AB: "Listing AB",
                        LISTING_SHOP: "Listing Shop",
                        LISTING_EXCLUSION_RULES_APPLY: "Application of listing exclusion rules",
                        NS_INVENTORY_AVAILABILITY_SYNC: "NetSuite inventory availability synchronization",
                        PARENT_ITEM_SYNC: "Parent item synchronization",
                        TEST: "Test",
                        TEST_MODULE: "Test Module"
                    }
                },
                LISTING_EXCLUSION_RULES: {
                    LABEL: "Listing exclusion rules",
                    DESCRIPTION: "Application of exclusion rules to the listing of a subset of catalog items"
                }, 
                AVAILABILITY_PRICE:{
                    LABEL:"Outbound Availability and Prices",
                    DESCRIPTION:"",
                },
                AVAILABILITY_PRICE_RESULT:{
                    LABEL:" Inbound Availability and Prices Result",
                    DESCRIPTION:"",
                }
                
            },
            BC:{
                BUSINESS_CONDITION_1: {
                    LABEL: "Shop business conditions",
                    DESCRIPTION: "Application of business conditions to shops of a subset of catalog items"
                },
                BUSINESS_CONDITION_2: {
                    LABEL: "Item business conditions",
                    DESCRIPTION: "Application of business conditions to items of a subset of catalog items"
                }
            },
        },
        OTHER: {
            REPORT: {
                CATALOG_01: "Catalog export",
                FARFETCH_03: "catalog anomalies for Farfetch",
                LISTING_01: "Listing reconciliation",
                LISTING_02: "Listing status",
                ORDERS_01: "Expired Orders",
                ORDERS_02: "Orders by Shop",
                SHOP_01: "Catalog by Shop",
                SHOPIFY_01: "Duplicated SKU for Shopify",
                TEST_01: "Test 1",
                TEST_02: "Test 2",
                TEST_03: "Test 3",
                WHS_01: "Warehouse availabilities",
            }
        }
    },
    STREAMS: {
        INVENTORY_AND_CATALOG_INBOUND: "Inventory / Catalog inbound",
        ORDER_INBOUND: "Order inbound",
        ORDER_DOCUMENTS_INBOUND: "Order documents inbound",
        RETURN_INBOUND: "Returns inbound",
        RETURN_REQUEST_INBOUND: "Returns request inbound",
        SHIPMENT_INBOUND: "Shipment inbound",
        AVAILABILITY_AND_PRICES_OUTBOUND: "Availability and prices outbound",
        ITEM_OUTBOUND: "Item outbound",
        ORDER_CANCELLATION_OUTBOUND: "Order cancellation outbound",
        ORDER_REPLY_OUTBOUND: "Order reply outbound",
        ORDER_PACKAGING_OUTBOUND: "Order packaging outbound",
        RETURN_OUTBOUND: "Return outbound",
        RETURN_REQUEST_REPLY_OUTBOUND: "Return request reply outbound",
        SHIPMENT_OUTBOUND: "Shipment outbound",
        PAYMENT_OUTBOUND: "Payment outbound",
        ORDER_INBOUND_PRICE_CHECK_CONFIG: {
            CONTROLLO_ATTIVO: "Check enabled",
            TIPO_TOLLERANZA: "Tolerance type",
            ASSOLUTO: "Absolute",
            PERCENTUALE: "Percentage",
            VALORE_TOLLERANZA: "Tolerance value",
            SCRIVI_NEL_REGISTRO_ATTIVITA: "Write in the Activity Log",
            BLOCCA_RISPOSTA: "Block response",
            MAI: "Never",
            SOLO_SE_MINORE: "Only if the price is lower than the minimum limit",
            SOLO_SE_MAGGIORE: "Only if the price is higher than the maximum limit",
            MAGGIORE_MINORE: "If the price is lower than the minimum limit or higher than the maximum limit"
        },
        REPLY_POLICIES: {
            REPLY_ALWAYS: "Automatic without inventory control",
            REPLY_NEVER: "Manual",
            REPLY_IF_IN_CATALOG: "Automatic only if in inventory",
            REPLY_IF_IN_CATALOG_AND_AVAILABLE: "Automatic if available"
        },
        ERRORE_POLICY_DIVERSA_NONE_CONTROLLO_PREZZI_NON_ATTIVO: "If price check is not active, this value must be set to 'Never'.",
        CONTROLLO_PREZZI_DISABILITATO_SE_INBOUND_ORDER_NON_ATTIVO: "Price check cannot be enabled if order inbound is disabled.",
        AVAILABILITY_AND_PRICES_OUTBOUND_OPTIONS: {
            AVAILABILITY: "Only availability",
            PRICES: "Only prices",
            AVAILABILITY_PRICES: "Availability and prices"
        },
        ITEM_OUTBOUND_ALWAYS_ENABLED: "For this shop the item outbound is always enabled.",
    },
    OVERRIDE_WAREHOUSE_ALGORITHM: {
        EREDITA_STRATEGIA_DEFAULT: "Inherit the default strategy",
        NONE: "NONE",
        NO_OP: "No operation",
        WHS_PRIORITY: "Warehouse priority",
        TEMP_COMMIT: "Temporary warehouse",
        SHOP_DRIVEN: "Shop driven"
    },
    FORMS: {
        ERRORI_NEL_FORM: "There are errors in the form fields, please check.",
        CAMPO_OBBLIGATORIO: "Required field",
        LUNGHEZZA_COMPRESA: "The field length must be between __MIN__ and __MAX__ characters.",
        VALORE_COMPRESO: "The field value must be between __MIN__ and __MAX__.",
        EMAIL_NON_VALIDA: "Invalid email",
        FORMATO_UUID_NON_VALIDO: "The field value must be in UUID format",
        ERRORE_REGEX: "Wrong format",
        VALORE_GIA_IN_USO: "Value already in use",
    },
    TRACKING: {
        TITLE: "Tracking",
        LINK: "Show tracking",
        MODAL_TITLE: (correlationUUID:string)=>`Tracking for Correlation UUID ${correlationUUID}`,
        TABLE: {
            ID: "ID",
            TIPO: "Type",
            TEMPO_DI_RISPOSTA: "Response time",
            CONTEXT: {
                MOSTRA_DETTAGLIO: "Show details",
                COPIA_ID: "Copy ID"
            }
        },
        DETAILS: {
            DATI_GENERALI: "General data",
            RICHIESTA: "Request",
            RISPOSTA: "Response",
            INFORMAZIONI: "Info",
            ATTRIBUTI: "Attributes",
            INFO: {
                DATA: "Date",
                URI: "URI",
                METODO_HTTP: "HTTP method",
                TIPO_PAYLOAD: "Payload type",
                CODICE_HTTP: "HTTP Code",
                ERRORE: "Error",
            }
        }
    },
    LANGUAGES : {
        DE: "German",
        DK: "Danish",
        ES: "Spanish",
        EU: "European Union",
        FR: "French",
        EN: "English",
        IT: "Italian",
        RU: "Russian",
        SE: "Swedish",
        CN: "Chinese",
        KR: "Korean",
    },
    TREE_SEARCH : {
        OTHER_RESULTS : " Show more results (__REMINIG__ remaining )",
    },
    COMPONENT_PRICEBOOKS: {
        CURRENCY: "Currency",
        STOCK_PRICEBOOK: "Stock price",
        SALE_PRICEBOOK: "Sale price",
        AGGIUNGI: "Add",
        RIMUOVI: "Remove",
        SELECT_PRICEBOOK:"Select Pricebook",
        INCLUDES_VAT:"Include Vat"
    },
    COUNTRIES: {
        SPAGNA: "Spain",
        REGNO_UNITO: "U.K.",
        FRANCIA: "France",
        BELGIO: "Belgium",
        PAESI_BASSI: "Netherlands",
        GERMANIA: "Germany",
        ITALIA: "Italy",
        SVEZIA: "Sweden",
        POLONIA: "Poland"
    },
    HOME_WIDGETS: {
        ORDINI_DI_OGGI: "Today's orders",
        NESSUN_ORDINE_OGGI: "No new order.",
        FATTURATO: {
            TITLE: "Sales",
            SUB_TITLE: "Today's orders data",
            TOTALE: "Total",
            ARTICOLI: "Items",
            ORDINI: "Orders",
            FATTURATO_DI_OGGI: "Today's sales",
        },
        ESPOSIZIONE_CATALOGO: {
            TITLE: "Catalog exposure",
            SUB_TITLE: "Catalog exposure statistics for your shops",
            VALORI_MEDI: "Average values",
            CONTROVALORE: "Countervalue",
            QUANTITA: "Quantity",
            TAGLIE: "Size #",
            ARTICOLI: "Item #"
        },
        STAMPA_ETICHETTE: {
            TITLE: "Print Labels",
            SUB_TITLE: "Print labels for your orders",
        }
    },
    YOOX_SALE_CHANNEL : {
        BE: 'Benelux',
        CEU: 'Central Europe',
        DE: 'Germany, Austria',
        DK: 'Scandinavia-Eire',
        EEU: 'Eastern',
        ES: 'Spain',
        FR: 'France',
        GR: 'Greece',
        IT: 'Italy',
        NL: 'Netherlands',
        SEU: 'Southern Europe',
    },
    GLF_SALE_CHANNEL:{
        FR: 'Private Sales Channel (Francia)' 
    },
    DECATHLON_SALE_CHANNEL:{
        BE: 'Belgium',
        DE: 'Germany',
        ES: 'Spain',
        FR: 'France',
        IT: 'Italy',
        NL: 'Netherlands',
    },
    ABOUT_YOU_SALE_CHANNEL:{
        DE: "Germany",
        AT: "Austria",
        NL: "Netherlands",
        BE: "Belgium",
        FR: "France",
        DK: "Denmark",
        SE: "Sweden",
        FI: "Finland",
        ES: "Spain",
        IT: "Italy",
    },
    MODIVO_SALE_CHANNEL:{
        CS: 'Czech Republic',
        EL: 'Greece',
        IT: 'Italy',
        PL: "Poland",
        SK: 'Slovakia',
    },
    ZALANDO_SALE_CHANNEL:{
        DE: 'Germany',
        NL: 'Netherlands',
        FR: 'France',
        IT: 'Italy',
        UK: 'United Kingdom',
        AT: 'Austria',
        CH: 'Switzerland',
        PL: 'Poland',
        BE: 'Belgium',
        SE: 'Sweden',
        FI: 'Finland',
        DK: 'Denmark',
        ES: 'Spain',
        NO: 'Norway',
        CZ: 'Czech Republic',
        IE: 'Ireland',
        PT: 'Portugal',
        SK: 'Slovakia',
        SI: 'Slovenia',
        LT: 'Lithuania',
        LV: 'Latvia',
        EE: 'Estonia',
        HR: 'Croatia',
        HU: 'Hungary',
        RO: 'Romania'
    },
    COUNTRIES_CODE: {
        AC: "Ascension Island",
        AD: "Andorra",
        AE: "United Arab Emirates",
        AF: "Afghanistan",
        AG: "Antigua and Barbuda",
        AI: "Anguilla",
        AL: "Albania",
        AM: "Armenia",
        AO: "Angola",
        AQ: "Antarctica",
        AR: "Argentina",
        AS: "American Samoa",
        AT: "Austria",
        AU: "Australia",
        AW: "Aruba",
        AX: "Åland Islands",
        AZ: "Azerbaijan",
        BA: "Bosnia and Herzegovina",
        BB: "Barbados",
        BD: "Bangladesh",
        BE: "Belgium",
        BF: "Burkina Faso",
        BG: "Bulgaria",
        BH: "Bahrain",
        BI: "Burundi",
        BJ: "Benin",
        BL: "Saint Barthélemy",
        BM: "Bermuda",
        BN: "Brunei",
        BO: "Bolivia",
        BQ: "Caribbean Netherlands",
        BR: "Brazil",
        BS: "Bahamas",
        BT: "Bhutan",
        BV: "Bouvet Island",
        BW: "Botswana",
        BY: "Belarus",
        BZ: "Belize",
        CA: "Canada",
        CC: "Cocos (Keeling) Islands",
        CD: "Congo (Kinshasa)",
        CF: "Central African Republic",
        CG: "Congo (Brazzaville)",
        CH: "Switzerland",
        CI: "Côte d'Ivoire",
        CK: "Cook Islands",
        CL: "Chile",
        CM: "Cameroon",
        CN: "China",
        CO: "Colombia",
        CR: "Costa Rica",
        CU: "Cuba",
        CV: "Cape Verde",
        CW: "Curaçao",
        CX: "Christmas Island",
        CY: "Cyprus",
        CZ: "Czech Republic",
        DE: "Germany",
        DJ: "Djibouti",
        DK: "Denmark",
        DM: "Dominica",
        DO: "Dominican Republic",
        DZ: "Algeria",
        EC: "Ecuador",
        EE: "Estonia",
        EG: "Egypt",
        EH: "Western Sahara",
        ER: "Eritrea",
        ES: "Spain",
        ET: "Ethiopia",
        FI: "Finland",
        FJ: "Fiji",
        FK: "Falkland Islands",
        FM: "Micronesia",
        FO: "Faroe Islands",
        FR: "France",
        GA: "Gabon",
        GB: "United Kingdom",
        GD: "Grenada",
        GE: "Georgia",
        GF: "French Guiana",
        GG: "Guernsey",
        GH: "Ghana",
        GI: "Gibraltar",
        GL: "Greenland",
        GM: "Gambia",
        GN: "Guinea",
        GP: "Guadeloupe",
        GQ: "Equatorial Guinea",
        GR: "Greece",
        GS: "South Georgia and the South Sandwich Islands",
        GT: "Guatemala",
        GU: "Guam",
        GW: "Guinea-Bissau",
        GY: "Guyana",
        HK: "Hong Kong",
        HM: "Heard Island and McDonald Islands",
        HN: "Honduras",
        HR: "Croatia",
        HT: "Haiti",
        HU: "Hungary",
        ID: "Indonesia",
        IE: "Ireland",
        IL: "Israel",
        IM: "Isle of Man",
        IN: "India",
        IO: "British Indian Ocean Territory",
        IQ: "Iraq",
        IR: "Iran",
        IS: "Iceland",
        IT: "Italy",
        JE: "Jersey",
        JM: "Jamaica",
        JO: "Jordan",
        JP: "Japan",
        KE: "Kenya",
        KG: "Kyrgyzstan",
        KH: "Cambodia",
        KI: "Kiribati",
        KM: "Comoros",
        KN: "Saint Kitts and Nevis",
        KP: "North Korea",
        KR: "South Korea",
        KW: "Kuwait",
        KY: "Cayman Islands",
        KZ: "Kazakhstan",
        LA: "Laos",
        LB: "Lebanon",
        LC: "Saint Lucia",
        LI: "Liechtenstein",
        LK: "Sri Lanka",
        LR: "Liberia",
        LS: "Lesotho",
        LT: "Lithuania",
        LU: "Luxembourg",
        LV: "Latvia",
        LY: "Libya",
        MA: "Morocco",
        MC: "Monaco",
        MD: "Moldova",
        ME: "Montenegro",
        MF: "Saint Martin",
        MG: "Madagascar",
        MH: "Marshall Islands",
        MK: "North Macedonia",
        ML: "Mali",
        MM: "Myanmar (Burma)",
        MN: "Mongolia",
        MO: "Macau",
        MP: "Northern Mariana Islands",
        MQ: "Martinique",
        MR: "Mauritania",
        MS: "Montserrat",
        MT: "Malta",
        MU: "Mauritius",
        MV: "Maldives",
        MW: "Malawi",
        MX: "Mexico",
        MY: "Malaysia",
        MZ: "Mozambique",
        NA: "Namibia",
        NC: "New Caledonia",
        NE: "Niger",
        NF: "Norfolk Island",
        NG: "Nigeria",
        NI: "Nicaragua",
        NL: "Netherlands",
        NO: "Norway",
        NP: "Nepal",
        NR: "Nauru",
        NU: "Niue",
        NZ: "New Zealand",
        OM: "Oman",
        PA: "Panama",
        PE: "Peru",
        PF: "French Polynesia",
        PG: "Papua New Guinea",
        PH: "Philippines",
        PK: "Pakistan",
        PL: "Poland",
        PM: "Saint Pierre and Miquelon",
        PN: "Pitcairn Islands",
        PR: "Puerto Rico",
        PS: "Palestine",
        PT: "Portugal",
        PW: "Palau",
        PY: "Paraguay",
        QA: "Qatar",
        RE: "Réunion",
        RO: "Romania",
        RS: "Serbia",
        RU: "Russia",
        RW: "Rwanda",
        SA: "Saudi Arabia",
        SB: "Solomon Islands",
        SC: "Seychelles",
        SD: "Sudan",
        SE: "Sweden",
        SG: "Singapore",
        SH: "Saint Helena",
        SI: "Slovenia",
        SJ: "Svalbard and Jan Mayen",
        SK: "Slovakia",
        SL: "Sierra Leone",
        SM: "San Marino",
        SN: "Senegal",
        SO: "Somalia",
        SR: "Suriname",
        SS: "South Sudan",
        ST: "São Tomé and Príncipe",
        SV: "El Salvador",
        SX: "Sint Maarten",
        SY: "Syria",
        SZ: "Eswatini",
        TC: "Turks and Caicos Islands",
        TD: "Chad",
        TF: "French Southern Territories",
        TG: "Togo",
        TH: "Thailand",
        TJ: "Tajikistan",
        TK: "Tokelau",
        TL: "Timor-Leste",
        TM: "Turkmenistan",
        TN: "Tunisia",
        TO: "Tonga",
        TR: "Turkey",
        TT: "Trinidad and Tobago",
        TV: "Tuvalu",
        TW: "Taiwan",
        TZ: "Tanzania",
        UA: "Ukraine",
        UG: "Uganda",
        UM: "United States Minor Outlying Islands",
        US: "United States",
        UY: "Uruguay",
        UZ: "Uzbekistan",
        VA: "Vatican City",
        VC: "Saint Vincent and the Grenadines",
        VE: "Venezuela",
        VG: "British Virgin Islands",
        VI: "U.S. Virgin Islands",
        VN: "Vietnam",
        VU: "Vanuatu",
        WF: "Wallis and Futuna",
        WS: "Samoa",
        XK: "Kosovo",
        YE: "Yemen",
        YT: "Mayotte",
        ZA: "South Africa",
        ZM: "Zambia",
        ZW: "Zimbabwe",
        UNDEFINED: "Undefined"
    },
    CURRENCY : {
        AED: "United Arab Emirates Dirham",
        AFN: "Afghani",
        ALL: "Lek",
        AMD: "Armenian Dram",
        ANG: "Netherlands Antillean Guilder",
        AOA: "Kwanza",
        ARS: "Argentine Peso",
        AUD: "Australian Dollar",
        AWG: "Aruban Florin",
        AZN: "Azerbaijan Manat",
        BAM: "Convertible Mark",
        BBD: "Barbados Dollar",
        BDT: "Taka",
        BGN: "Bulgarian Lev",
        BHD: "Bahraini Dinar",
        BIF: "Burundi Franc",
        BMD: "Bermudian Dollar",
        BND: "Brunei Dollar",
        BOB: "Boliviano",
        BRL: "Brazilian Real",
        BSD: "Bahamian Dollar",
        BTN: "Ngultrum",
        BWP: "Pula",
        BYN: "Belarusian Ruble",
        BZD: "Belize Dollar",
        CAD: "Canadian Dollar",
        CDF: "Congolese Franc",
        CHF: "Swiss Franc",
        CLP: "Chilean Peso",
        CNY: "Yuan Renminbi",
        COP: "Colombian Peso",
        CRC: "Costa Rican Colon",
        CUC: "Peso Convertible",
        CUP: "Cuban Peso",
        CVE: "Cabo Verde Escudo",
        CZK: "Czech Koruna",
        DJF: "Djibouti Franc",
        DKK: "Danish Krone",
        DOP: "Dominican Peso",
        DZD: "Algerian Dinar",
        EGP: "Egyptian Pound",
        ERN: "Nakfa",
        ETB: "Ethiopian Birr",
        EUR: "Euro",
        FJD: "Fiji Dollar",
        FKP: "Falkland Islands Pound",
        GBP: "Pound Sterling",
        GEL: "Lari",
        GHS: "Ghana Cedi",
        GIP: "Gibraltar Pound",
        GMD: "Dalasi",
        GNF: "Guinea Franc",
        GTQ: "Quetzal",
        GYD: "Guyana Dollar",
        HKD: "Hong Kong Dollar",
        HNL: "Lempira",
        HRK: "Kuna",
        HTG: "Gourde",
        HUF: "Forint",
        IDR: "Rupiah",
        ILS: "New Israeli Sheqel",
        INR: "Indian Rupee",
        IQD: "Iraqi Dinar",
        IRR: "Iranian Rial",
        ISK: "Iceland Krona",
        JMD: "Jamaican Dollar",
        JOD: "Jordanian Dinar",
        JPY: "Yen",
        KES: "Kenyan Shilling",
        KGS: "Som",
        KHR: "Riel",
        KMF: "Comoro Franc",
        KPW: "North Korean Won",
        KRW: "Won",
        KWD: "Kuwaiti Dinar",
        KYD: "Cayman Islands Dollar",
        KZT: "Tenge",
        LAK: "Kip",
        LBP: "Lebanese Pound",
        LKR: "Sri Lanka Rupee",
        LRD: "Liberian Dollar",
        LSL: "Loti",
        LYD: "Libyan Dinar",
        MAD: "Moroccan Dirham",
        MDL: "Moldovan Leu",
        MGA: "Malagasy Ariary",
        MKD: "Denar",
        MMK: "Kyat",
        MNT: "Tugrik",
        MOP: "Pataca",
        MRU: "Ouguiya",
        MUR: "Mauritius Rupee",
        MVR: "Rufiyaa",
        MWK: "Malawi Kwacha",
        MXN: "Mexican Peso",
        MYR: "Malaysian Ringgit",
        MZN: "Mozambique Metical",
        NAD: "Namibia Dollar",
        NGN: "Naira",
        NIO: "Cordoba Oro",
        NOK: "Norwegian Krone",
        NPR: "Nepalese Rupee",
        NZD: "New Zealand Dollar",
        OMR: "Rial Omani",
        PAB: "Balboa",
        PEN: "Sol",
        PGK: "Kina",
        PHP: "Philippine Peso",
        PKR: "Pakistan Rupee",
        PLN: "Zloty",
        PYG: "Guarani",
        QAR: "Qatari Rial",
        RON: "Romanian Leu",
        RSD: "Serbian Dinar",
        RUB: "Russian Ruble",
        RWF: "Rwanda Franc",
        SAR: "Saudi Riyal",
        SBD: "Solomon Islands Dollar",
        SCR: "Seychelles Rupee",
        SDG: "Sudanese Pound",
        SEK: "Swedish Krona",
        SGD: "Singapore Dollar",
        SHP: "Saint Helena Pound",
        SLL: "Leone",
        SOS: "Somali Shilling",
        SRD: "Surinam Dollar",
        SSP: "South Sudanese Pound",
        STN: "Dobra",
        SYP: "Syrian Pound",
        SZL: "Lilangeni",
        THB: "Baht",
        TJS: "Somoni",
        TMT: "Turkmenistan New Manat",
        TND: "Tunisian Dinar",
        TOP: "Paʻanga",
        TRY: "Turkish Lira",
        TTD: "Trinidad and Tobago Dollar",
        TWD: "New Taiwan Dollar",
        TZS: "Tanzanian Shilling",
        UAH: "Hryvnia",
        UGX: "Uganda Shilling",
        USD: "US Dollar",
        UYU: "Peso Uruguayo",
        UZS: "Uzbekistan Sum",
        VES: "Bolívar Soberano",
        VND: "Dong",
        VUV: "Vatu",
        WST: "Tala",
        XAF: "CFA Franc BEAC",
        XCD: "East Caribbean Dollar",
        XOF: "CFA Franc BCEAO",
        XPF: "CFP Franc",
        YER: "Yemeni Rial",
        ZAR: "Rand",
        ZMW: "Zambian Kwacha",
        ZWL: "Zimbabwe Dollar"
    },
    DAYS_OF_WEEK: {
        DOMENICA: "Sunday",
        LUNEDI: "Monday",
        MARTEDI: "Tuesday",
        MERCOLEDI: "Wednesday",
        GIOVEDI: "Thursday",
        VENERDI: "Friday",
        SABATO: "Saturday"
    },
    MONTHS: {
        GENNAIO: "Gennaio",
        FEBBRAIO: "Febbraio",
        MARZO: "Marzo",
        APRILE: "Aprile",
        MAGGIO: "Maggio",
        GIUGNO: "Giugno",
        LUGLIO: "Luglio",
        AGOSTO: "Agosto",
        SETTEMBRE: "Settembre",
        OTTOBRE: "Ottobre",
        NOVEMBRE: "Novembre",
        DICEMBRE: "Dicembre"
    }
}

export default en